// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v5.29.3
// source: general.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  LocationStatus,
  locationStatusFromJSON,
  locationStatusToJSON,
  locationStatusToNumber,
  UserRole,
  userRoleFromJSON,
  userRoleToJSON,
  userRoleToNumber,
} from "./enums";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "raccoonai";

export enum ErrorCode {
  ERROR_CODE_UNDEFINED = "ERROR_CODE_UNDEFINED",
  /** ERROR_CODE_AUTH_HEADER_ISSUE - Authentication */
  ERROR_CODE_AUTH_HEADER_ISSUE = "ERROR_CODE_AUTH_HEADER_ISSUE",
  ERROR_CODE_AUTH_TOKEN_ISSUE = "ERROR_CODE_AUTH_TOKEN_ISSUE",
  ERROR_CODE_AUTH_TOKEN_INVALID = "ERROR_CODE_AUTH_TOKEN_INVALID",
  ERROR_CODE_AUTH_MISSING_CTX = "ERROR_CODE_AUTH_MISSING_CTX",
  ERROR_CODE_INVALID_CREDENTIALS = "ERROR_CODE_INVALID_CREDENTIALS",
  /**
   * ERROR_CODE_AUTH_EXPIRED - Access token (or other credential, e.g. registration token) has expired.
   * For an expired access token the client should call RefreshToken.
   */
  ERROR_CODE_AUTH_EXPIRED = "ERROR_CODE_AUTH_EXPIRED",
  ERROR_CODE_AUTH_INVALID_USER_DATA = "ERROR_CODE_AUTH_INVALID_USER_DATA",
  ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED = "ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED",
  ERROR_CODE_OTP_SERVICE_ISSUE = "ERROR_CODE_OTP_SERVICE_ISSUE",
  ERROR_CODE_OTP_INVALID = "ERROR_CODE_OTP_INVALID",
  ERROR_CODE_OTP_EXPIRED = "ERROR_CODE_OTP_EXPIRED",
  ERROR_CODE_OTP_RATE_LIMIT = "ERROR_CODE_OTP_RATE_LIMIT",
  ERROR_CODE_PASSWORD_RESET_ISSUE = "ERROR_CODE_PASSWORD_RESET_ISSUE",
  ERROR_CODE_OTP_EMAIL_REQUIRED = "ERROR_CODE_OTP_EMAIL_REQUIRED",
  ERROR_CODE_OTP_PHONE_REQUIRED = "ERROR_CODE_OTP_PHONE_REQUIRED",
  ERROR_CODE_USER_INACTIVE = "ERROR_CODE_USER_INACTIVE",
  /**
   * ERROR_CODE_REFRESH_TOKEN_INVALID - Refresh token is malformed, has a bad signature, or is not a refresh
   * token. Client must re-login.
   */
  ERROR_CODE_REFRESH_TOKEN_INVALID = "ERROR_CODE_REFRESH_TOKEN_INVALID",
  /** ERROR_CODE_REFRESH_TOKEN_EXPIRED - Refresh token has expired. Client must re-login. */
  ERROR_CODE_REFRESH_TOKEN_EXPIRED = "ERROR_CODE_REFRESH_TOKEN_EXPIRED",
  /**
   * ERROR_CODE_SESSION_REVOKED - The session behind the token no longer exists: logged out, revoked, or
   * killed after refresh-token reuse was detected. Client must re-login.
   */
  ERROR_CODE_SESSION_REVOKED = "ERROR_CODE_SESSION_REVOKED",
  /** ERROR_CODE_PERMISSION_DENIED - Permission/Authorization errors */
  ERROR_CODE_PERMISSION_DENIED = "ERROR_CODE_PERMISSION_DENIED",
  ERROR_CODE_NO_ACCESS = "ERROR_CODE_NO_ACCESS",
  ERROR_CODE_INVALID_PERMISSION_REQUEST = "ERROR_CODE_INVALID_PERMISSION_REQUEST",
  ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED = "ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED",
  ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED = "ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED",
  ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED = "ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED",
  ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED = "ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED",
  ERROR_CODE_GRANT_OPERATION_FAILED = "ERROR_CODE_GRANT_OPERATION_FAILED",
  ERROR_CODE_MEMBERSHIP_OPERATION_FAILED = "ERROR_CODE_MEMBERSHIP_OPERATION_FAILED",
  ERROR_CODE_ADMIN_ACTION_REQUIRED = "ERROR_CODE_ADMIN_ACTION_REQUIRED",
  ERROR_CODE_UNDEFINED_ROLE = "ERROR_CODE_UNDEFINED_ROLE",
  ERROR_CODE_ROLE_NOT_ALLOWED = "ERROR_CODE_ROLE_NOT_ALLOWED",
  /** ERROR_CODE_REQUIRED_FIELD_MISSING - Validation errors */
  ERROR_CODE_REQUIRED_FIELD_MISSING = "ERROR_CODE_REQUIRED_FIELD_MISSING",
  ERROR_CODE_INVALID_FIELD_VALUE = "ERROR_CODE_INVALID_FIELD_VALUE",
  ERROR_CODE_DUPLICATE_ENTRY = "ERROR_CODE_DUPLICATE_ENTRY",
  ERROR_CODE_INVALID_FORMAT = "ERROR_CODE_INVALID_FORMAT",
  ERROR_CODE_VALUE_TOO_SHORT = "ERROR_CODE_VALUE_TOO_SHORT",
  ERROR_CODE_VALUE_TOO_LONG = "ERROR_CODE_VALUE_TOO_LONG",
  ERROR_CODE_OUT_OF_RANGE = "ERROR_CODE_OUT_OF_RANGE",
  ERROR_CODE_FILE_REQUIRED = "ERROR_CODE_FILE_REQUIRED",
  ERROR_CODE_FILTER_REQUIRED = "ERROR_CODE_FILTER_REQUIRED",
  ERROR_CODE_FILTER_INVALID = "ERROR_CODE_FILTER_INVALID",
  ERROR_CODE_INVALID_ENUM_VALUE = "ERROR_CODE_INVALID_ENUM_VALUE",
  ERROR_CODE_INVALID_REQUEST_STATE = "ERROR_CODE_INVALID_REQUEST_STATE",
  ERROR_CODE_ORGANIZATION_TYPE_MISMATCH = "ERROR_CODE_ORGANIZATION_TYPE_MISMATCH",
  ERROR_CODE_INVALID_VALUE = "ERROR_CODE_INVALID_VALUE",
  /** ERROR_CODE_CONTRACT_NOT_FOUND - Validation errors related to contracts */
  ERROR_CODE_CONTRACT_NOT_FOUND = "ERROR_CODE_CONTRACT_NOT_FOUND",
  ERROR_CODE_CONTRACT_EXPIRED = "ERROR_CODE_CONTRACT_EXPIRED",
  ERROR_CODE_CONTRACT_NOT_ACTIVE = "ERROR_CODE_CONTRACT_NOT_ACTIVE",
  ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND = "ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND",
  /** ERROR_CODE_FILE_INVALID_BASE64 - File / storage errors */
  ERROR_CODE_FILE_INVALID_BASE64 = "ERROR_CODE_FILE_INVALID_BASE64",
  ERROR_CODE_FILE_UPLOAD_FAILED = "ERROR_CODE_FILE_UPLOAD_FAILED",
  ERROR_CODE_FILE_TYPE_INVALID = "ERROR_CODE_FILE_TYPE_INVALID",
  /** ERROR_CODE_NOT_FOUND - Look-up errors */
  ERROR_CODE_NOT_FOUND = "ERROR_CODE_NOT_FOUND",
  ERROR_CODE_MULTIPLE_FOUND = "ERROR_CODE_MULTIPLE_FOUND",
  ERROR_CODE_INVALID_ID = "ERROR_CODE_INVALID_ID",
  ERROR_CODE_INVALID_QUERY = "ERROR_CODE_INVALID_QUERY",
  ERROR_CODE_RELATED_ENTITY_NOT_FOUND = "ERROR_CODE_RELATED_ENTITY_NOT_FOUND",
  ERROR_CODE_ORGANIZATION_NOT_FOUND = "ERROR_CODE_ORGANIZATION_NOT_FOUND",
  ERROR_CODE_CONTAINER_TYPE_NOT_FOUND = "ERROR_CODE_CONTAINER_TYPE_NOT_FOUND",
  ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER = "ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER",
  ERROR_CODE_LOOKUP_FAILED = "ERROR_CODE_LOOKUP_FAILED",
  ERROR_CODE_SHIFT_ALREADY_EXISTS = "ERROR_CODE_SHIFT_ALREADY_EXISTS",
  /** ERROR_CODE_CREATION_NOT_ALLOWED - Creation errors */
  ERROR_CODE_CREATION_NOT_ALLOWED = "ERROR_CODE_CREATION_NOT_ALLOWED",
  ERROR_CODE_CREATE_ISSUE = "ERROR_CODE_CREATE_ISSUE",
  ERROR_CODE_DUPLICATE_PHONE_NUMBER = "ERROR_CODE_DUPLICATE_PHONE_NUMBER",
  ERROR_CODE_DUPLICATE_EMAIL = "ERROR_CODE_DUPLICATE_EMAIL",
  ERROR_CODE_ALREADY_EXISTS = "ERROR_CODE_ALREADY_EXISTS",
  ERROR_CODE_CREATION_FAILED = "ERROR_CODE_CREATION_FAILED",
  /** ERROR_CODE_UPDATE_NOT_ALLOWED - Update errors */
  ERROR_CODE_UPDATE_NOT_ALLOWED = "ERROR_CODE_UPDATE_NOT_ALLOWED",
  ERROR_CODE_UPDATE_FAILED = "ERROR_CODE_UPDATE_FAILED",
  ERROR_CODE_UPDATE_INVALID = "ERROR_CODE_UPDATE_INVALID",
  /** ERROR_CODE_DELETION_NOT_ALLOWED - Deletion errors */
  ERROR_CODE_DELETION_NOT_ALLOWED = "ERROR_CODE_DELETION_NOT_ALLOWED",
  ERROR_CODE_DELETION_FAILED = "ERROR_CODE_DELETION_FAILED",
  ERROR_CODE_DELETION_INVALID = "ERROR_CODE_DELETION_INVALID",
  /** ERROR_CODE_GORM_TO_PROTO_CONVERSION - Internal server errors */
  ERROR_CODE_GORM_TO_PROTO_CONVERSION = "ERROR_CODE_GORM_TO_PROTO_CONVERSION",
  ERROR_CODE_PROTO_TO_GORM_CONVERSION = "ERROR_CODE_PROTO_TO_GORM_CONVERSION",
  ERROR_CODE_DATA_MARSHALING_FAILED = "ERROR_CODE_DATA_MARSHALING_FAILED",
  ERROR_CODE_INTERNAL = "ERROR_CODE_INTERNAL",
  /** ERROR_CODE_PERMIFY_ISSUE - External service errors */
  ERROR_CODE_PERMIFY_ISSUE = "ERROR_CODE_PERMIFY_ISSUE",
  /** ERROR_CODE_STORAGE_SERVICE_ISSUE - Unexpected error from file storage service (e.g., S3) */
  ERROR_CODE_STORAGE_SERVICE_ISSUE = "ERROR_CODE_STORAGE_SERVICE_ISSUE",
  ERROR_CODE_WHATSAPP_SENDING_ISSUE = "ERROR_CODE_WHATSAPP_SENDING_ISSUE",
  ERROR_CODE_EMAIL_SENDING_ISSUE = "ERROR_CODE_EMAIL_SENDING_ISSUE",
  ERROR_CODE_DATABASE_ISSUE = "ERROR_CODE_DATABASE_ISSUE",
  ERROR_CODE_NOSQL_DATABASE_ISSUE = "ERROR_CODE_NOSQL_DATABASE_ISSUE",
  ERROR_CODE_VRP_SERVICE_ISSUE = "ERROR_CODE_VRP_SERVICE_ISSUE",
  ERROR_CODE_COST_PROVIDER_ISSUE = "ERROR_CODE_COST_PROVIDER_ISSUE",
  ERROR_CODE_VOXIMPLANT_ISSUE = "ERROR_CODE_VOXIMPLANT_ISSUE",
  ERROR_CODE_ENCRYPTION_FAILED = "ERROR_CODE_ENCRYPTION_FAILED",
  ERROR_CODE_DECRYPTION_FAILED = "ERROR_CODE_DECRYPTION_FAILED",
  /** ERROR_CODE_ROUTE_FINAL - route */
  ERROR_CODE_ROUTE_FINAL = "ERROR_CODE_ROUTE_FINAL",
  ERROR_CODE_ROUTE_NOT_RETURNING = "ERROR_CODE_ROUTE_NOT_RETURNING",
  ERROR_CODE_ROUTE_INVALID_TRANSITION = "ERROR_CODE_ROUTE_INVALID_TRANSITION",
  ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT = "ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT",
  ERROR_CODE_ROUTE_NOT_APPROVABLE = "ERROR_CODE_ROUTE_NOT_APPROVABLE",
  ERROR_CODE_ROUTE_NOT_APPROVED = "ERROR_CODE_ROUTE_NOT_APPROVED",
  ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED = "ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED",
  ERROR_CODE_ROUTE_NO_DESTINATION = "ERROR_CODE_ROUTE_NO_DESTINATION",
  ERROR_CODE_ROUTE_NOT_DISSOLVABLE = "ERROR_CODE_ROUTE_NOT_DISSOLVABLE",
  ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION = "ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION",
  ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS = "ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS",
  ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE = "ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE",
  ERROR_CODE_ROUTE_DURATION_TOO_SHORT = "ERROR_CODE_ROUTE_DURATION_TOO_SHORT",
  ERROR_CODE_ROUTE_STOP_AMBIGUOUS = "ERROR_CODE_ROUTE_STOP_AMBIGUOUS",
  ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB = "ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB",
  ERROR_CODE_ROUTE_RETURNING = "ERROR_CODE_ROUTE_RETURNING",
  ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE = "ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE",
  /** ERROR_CODE_JOB_NOT_IN_ROUTE - job */
  ERROR_CODE_JOB_NOT_IN_ROUTE = "ERROR_CODE_JOB_NOT_IN_ROUTE",
  ERROR_CODE_JOB_ALREADY_ON_SERVICE = "ERROR_CODE_JOB_ALREADY_ON_SERVICE",
  ERROR_CODE_JOB_NOT_ON_SERVICE = "ERROR_CODE_JOB_NOT_ON_SERVICE",
  ERROR_CODE_JOB_FINAL = "ERROR_CODE_JOB_FINAL",
  ERROR_CODE_JOB_NOT_DETACHABLE = "ERROR_CODE_JOB_NOT_DETACHABLE",
  ERROR_CODE_JOB_INVALID_TRANSITION = "ERROR_CODE_JOB_INVALID_TRANSITION",
  ERROR_CODE_JOB_NOT_ENROUTE = "ERROR_CODE_JOB_NOT_ENROUTE",
  ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT = "ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT",
  ERROR_CODE_JOB_NOT_COMPLETED = "ERROR_CODE_JOB_NOT_COMPLETED",
  ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE = "ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE",
  ERROR_CODE_JOB_LIST_CONFLICT = "ERROR_CODE_JOB_LIST_CONFLICT",
  ERROR_CODE_JOB_NOT_LISTED = "ERROR_CODE_JOB_NOT_LISTED",
  ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY = "ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY",
  ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH = "ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH",
  ERROR_CODE_JOB_HAS_NO_ROUTE = "ERROR_CODE_JOB_HAS_NO_ROUTE",
  ERROR_CODE_JOB_ALREADY_ASSIGNED = "ERROR_CODE_JOB_ALREADY_ASSIGNED",
  ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE = "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE",
  ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE = "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE",
  /** ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE - driver_on_shift */
  ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE = "ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE",
  ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER = "ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER",
  ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY = "ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY",
  ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY = "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY",
  ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT = "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT",
  ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION = "ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION",
  ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED = "ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED",
  ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE = "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE",
  ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK = "ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK",
  ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE = "ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE",
  ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT = "ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT",
  ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE = "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE",
  ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED = "ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED",
  /** ERROR_CODE_TRUCK_JOB_LIMIT - truck */
  ERROR_CODE_TRUCK_JOB_LIMIT = "ERROR_CODE_TRUCK_JOB_LIMIT",
  ERROR_CODE_TRUCK_JOB_INCOMPATIBLE = "ERROR_CODE_TRUCK_JOB_INCOMPATIBLE",
  ERROR_CODE_TRUCK_NO_DEPOT = "ERROR_CODE_TRUCK_NO_DEPOT",
  ERROR_CODE_TRUCK_NO_TYPE = "ERROR_CODE_TRUCK_NO_TYPE",
  ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET = "ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET",
  ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET = "ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET",
  ERROR_CODE_TRUCK_NOT_ACTIVE = "ERROR_CODE_TRUCK_NOT_ACTIVE",
  /** ERROR_CODE_CONTAINER_GROUP_NOT_BOUND - contract / container_group */
  ERROR_CODE_CONTAINER_GROUP_NOT_BOUND = "ERROR_CODE_CONTAINER_GROUP_NOT_BOUND",
  ERROR_CODE_CONTRACT_PARTIES_MISMATCH = "ERROR_CODE_CONTRACT_PARTIES_MISMATCH",
  ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE = "ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE",
  ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY = "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY",
  ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE = "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE",
  ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING =
    "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING",
  ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP = "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP",
  ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES = "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES",
  ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD = "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD",
  ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE = "ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE",
  /** ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE - pickup_location / pickup_location_group */
  ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE = "ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE",
  ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT = "ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT",
  ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED = "ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED",
  ERROR_CODE_PICKUP_LOCATION_TOO_FAR = "ERROR_CODE_PICKUP_LOCATION_TOO_FAR",
  ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK = "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK",
  ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS = "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS",
  /** ERROR_CODE_ORGANIZATION_MISMATCH - organization */
  ERROR_CODE_ORGANIZATION_MISMATCH = "ERROR_CODE_ORGANIZATION_MISMATCH",
  ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER = "ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER",
  ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER = "ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER",
  ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS = "ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS",
  ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE = "ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE",
  ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER = "ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER",
  ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT = "ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT",
  ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS = "ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS",
  ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH = "ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH",
  /** ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION - user / driver */
  ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION = "ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION",
  /** ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE - shift_plan */
  ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE = "ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE",
  ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER = "ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER",
  /** ERROR_CODE_CONTACT_NO_PHONE_NUMBER - contact */
  ERROR_CODE_CONTACT_NO_PHONE_NUMBER = "ERROR_CODE_CONTACT_NO_PHONE_NUMBER",
  /** ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED - driver_price_list */
  ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED = "ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED",
  ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY = "ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY",
  ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED = "ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED",
  ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE = "ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE",
  /** ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE - resource_access_grant */
  ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE = "ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE",
  /** ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED - whatsapp */
  ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED = "ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED",
  /** ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN - custom_group */
  ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN = "ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN",
  /** ERROR_CODE_TYPE_OUTSIDE_HOLDING - holding shared types: container and truck types are owned by the company that made them, used across its holding */
  ERROR_CODE_TYPE_OUTSIDE_HOLDING = "ERROR_CODE_TYPE_OUTSIDE_HOLDING",
  ERROR_CODE_TYPE_NOT_OWNED = "ERROR_CODE_TYPE_NOT_OWNED",
  ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING = "ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING",
  ERROR_CODE_TRUCK_TYPE_IN_USE = "ERROR_CODE_TRUCK_TYPE_IN_USE",
  /**
   * ERROR_CODE_COMPANY_NOT_SELECTED - Client-side conditions. The backend never sends these; they live here so a
   * client has one registry of every error it can show. Expect them in the
   * go-backend reachability report as permanently unreachable.
   */
  ERROR_CODE_COMPANY_NOT_SELECTED = "ERROR_CODE_COMPANY_NOT_SELECTED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "ERROR_CODE_UNDEFINED":
      return ErrorCode.ERROR_CODE_UNDEFINED;
    case 101:
    case "ERROR_CODE_AUTH_HEADER_ISSUE":
      return ErrorCode.ERROR_CODE_AUTH_HEADER_ISSUE;
    case 102:
    case "ERROR_CODE_AUTH_TOKEN_ISSUE":
      return ErrorCode.ERROR_CODE_AUTH_TOKEN_ISSUE;
    case 103:
    case "ERROR_CODE_AUTH_TOKEN_INVALID":
      return ErrorCode.ERROR_CODE_AUTH_TOKEN_INVALID;
    case 104:
    case "ERROR_CODE_AUTH_MISSING_CTX":
      return ErrorCode.ERROR_CODE_AUTH_MISSING_CTX;
    case 105:
    case "ERROR_CODE_INVALID_CREDENTIALS":
      return ErrorCode.ERROR_CODE_INVALID_CREDENTIALS;
    case 106:
    case "ERROR_CODE_AUTH_EXPIRED":
      return ErrorCode.ERROR_CODE_AUTH_EXPIRED;
    case 107:
    case "ERROR_CODE_AUTH_INVALID_USER_DATA":
      return ErrorCode.ERROR_CODE_AUTH_INVALID_USER_DATA;
    case 108:
    case "ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED":
      return ErrorCode.ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED;
    case 109:
    case "ERROR_CODE_OTP_SERVICE_ISSUE":
      return ErrorCode.ERROR_CODE_OTP_SERVICE_ISSUE;
    case 110:
    case "ERROR_CODE_OTP_INVALID":
      return ErrorCode.ERROR_CODE_OTP_INVALID;
    case 111:
    case "ERROR_CODE_OTP_EXPIRED":
      return ErrorCode.ERROR_CODE_OTP_EXPIRED;
    case 112:
    case "ERROR_CODE_OTP_RATE_LIMIT":
      return ErrorCode.ERROR_CODE_OTP_RATE_LIMIT;
    case 113:
    case "ERROR_CODE_PASSWORD_RESET_ISSUE":
      return ErrorCode.ERROR_CODE_PASSWORD_RESET_ISSUE;
    case 114:
    case "ERROR_CODE_OTP_EMAIL_REQUIRED":
      return ErrorCode.ERROR_CODE_OTP_EMAIL_REQUIRED;
    case 115:
    case "ERROR_CODE_OTP_PHONE_REQUIRED":
      return ErrorCode.ERROR_CODE_OTP_PHONE_REQUIRED;
    case 116:
    case "ERROR_CODE_USER_INACTIVE":
      return ErrorCode.ERROR_CODE_USER_INACTIVE;
    case 117:
    case "ERROR_CODE_REFRESH_TOKEN_INVALID":
      return ErrorCode.ERROR_CODE_REFRESH_TOKEN_INVALID;
    case 118:
    case "ERROR_CODE_REFRESH_TOKEN_EXPIRED":
      return ErrorCode.ERROR_CODE_REFRESH_TOKEN_EXPIRED;
    case 119:
    case "ERROR_CODE_SESSION_REVOKED":
      return ErrorCode.ERROR_CODE_SESSION_REVOKED;
    case 201:
    case "ERROR_CODE_PERMISSION_DENIED":
      return ErrorCode.ERROR_CODE_PERMISSION_DENIED;
    case 202:
    case "ERROR_CODE_NO_ACCESS":
      return ErrorCode.ERROR_CODE_NO_ACCESS;
    case 203:
    case "ERROR_CODE_INVALID_PERMISSION_REQUEST":
      return ErrorCode.ERROR_CODE_INVALID_PERMISSION_REQUEST;
    case 204:
    case "ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED":
      return ErrorCode.ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED;
    case 205:
    case "ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED":
      return ErrorCode.ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED;
    case 206:
    case "ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED":
      return ErrorCode.ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED;
    case 207:
    case "ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED":
      return ErrorCode.ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED;
    case 211:
    case "ERROR_CODE_GRANT_OPERATION_FAILED":
      return ErrorCode.ERROR_CODE_GRANT_OPERATION_FAILED;
    case 212:
    case "ERROR_CODE_MEMBERSHIP_OPERATION_FAILED":
      return ErrorCode.ERROR_CODE_MEMBERSHIP_OPERATION_FAILED;
    case 213:
    case "ERROR_CODE_ADMIN_ACTION_REQUIRED":
      return ErrorCode.ERROR_CODE_ADMIN_ACTION_REQUIRED;
    case 220:
    case "ERROR_CODE_UNDEFINED_ROLE":
      return ErrorCode.ERROR_CODE_UNDEFINED_ROLE;
    case 221:
    case "ERROR_CODE_ROLE_NOT_ALLOWED":
      return ErrorCode.ERROR_CODE_ROLE_NOT_ALLOWED;
    case 301:
    case "ERROR_CODE_REQUIRED_FIELD_MISSING":
      return ErrorCode.ERROR_CODE_REQUIRED_FIELD_MISSING;
    case 302:
    case "ERROR_CODE_INVALID_FIELD_VALUE":
      return ErrorCode.ERROR_CODE_INVALID_FIELD_VALUE;
    case 303:
    case "ERROR_CODE_DUPLICATE_ENTRY":
      return ErrorCode.ERROR_CODE_DUPLICATE_ENTRY;
    case 304:
    case "ERROR_CODE_INVALID_FORMAT":
      return ErrorCode.ERROR_CODE_INVALID_FORMAT;
    case 305:
    case "ERROR_CODE_VALUE_TOO_SHORT":
      return ErrorCode.ERROR_CODE_VALUE_TOO_SHORT;
    case 306:
    case "ERROR_CODE_VALUE_TOO_LONG":
      return ErrorCode.ERROR_CODE_VALUE_TOO_LONG;
    case 307:
    case "ERROR_CODE_OUT_OF_RANGE":
      return ErrorCode.ERROR_CODE_OUT_OF_RANGE;
    case 308:
    case "ERROR_CODE_FILE_REQUIRED":
      return ErrorCode.ERROR_CODE_FILE_REQUIRED;
    case 309:
    case "ERROR_CODE_FILTER_REQUIRED":
      return ErrorCode.ERROR_CODE_FILTER_REQUIRED;
    case 310:
    case "ERROR_CODE_FILTER_INVALID":
      return ErrorCode.ERROR_CODE_FILTER_INVALID;
    case 311:
    case "ERROR_CODE_INVALID_ENUM_VALUE":
      return ErrorCode.ERROR_CODE_INVALID_ENUM_VALUE;
    case 312:
    case "ERROR_CODE_INVALID_REQUEST_STATE":
      return ErrorCode.ERROR_CODE_INVALID_REQUEST_STATE;
    case 313:
    case "ERROR_CODE_ORGANIZATION_TYPE_MISMATCH":
      return ErrorCode.ERROR_CODE_ORGANIZATION_TYPE_MISMATCH;
    case 314:
    case "ERROR_CODE_INVALID_VALUE":
      return ErrorCode.ERROR_CODE_INVALID_VALUE;
    case 330:
    case "ERROR_CODE_CONTRACT_NOT_FOUND":
      return ErrorCode.ERROR_CODE_CONTRACT_NOT_FOUND;
    case 331:
    case "ERROR_CODE_CONTRACT_EXPIRED":
      return ErrorCode.ERROR_CODE_CONTRACT_EXPIRED;
    case 332:
    case "ERROR_CODE_CONTRACT_NOT_ACTIVE":
      return ErrorCode.ERROR_CODE_CONTRACT_NOT_ACTIVE;
    case 333:
    case "ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND":
      return ErrorCode.ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND;
    case 320:
    case "ERROR_CODE_FILE_INVALID_BASE64":
      return ErrorCode.ERROR_CODE_FILE_INVALID_BASE64;
    case 321:
    case "ERROR_CODE_FILE_UPLOAD_FAILED":
      return ErrorCode.ERROR_CODE_FILE_UPLOAD_FAILED;
    case 322:
    case "ERROR_CODE_FILE_TYPE_INVALID":
      return ErrorCode.ERROR_CODE_FILE_TYPE_INVALID;
    case 401:
    case "ERROR_CODE_NOT_FOUND":
      return ErrorCode.ERROR_CODE_NOT_FOUND;
    case 402:
    case "ERROR_CODE_MULTIPLE_FOUND":
      return ErrorCode.ERROR_CODE_MULTIPLE_FOUND;
    case 403:
    case "ERROR_CODE_INVALID_ID":
      return ErrorCode.ERROR_CODE_INVALID_ID;
    case 404:
    case "ERROR_CODE_INVALID_QUERY":
      return ErrorCode.ERROR_CODE_INVALID_QUERY;
    case 405:
    case "ERROR_CODE_RELATED_ENTITY_NOT_FOUND":
      return ErrorCode.ERROR_CODE_RELATED_ENTITY_NOT_FOUND;
    case 406:
    case "ERROR_CODE_ORGANIZATION_NOT_FOUND":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NOT_FOUND;
    case 407:
    case "ERROR_CODE_CONTAINER_TYPE_NOT_FOUND":
      return ErrorCode.ERROR_CODE_CONTAINER_TYPE_NOT_FOUND;
    case 408:
    case "ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER":
      return ErrorCode.ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER;
    case 409:
    case "ERROR_CODE_LOOKUP_FAILED":
      return ErrorCode.ERROR_CODE_LOOKUP_FAILED;
    case 410:
    case "ERROR_CODE_SHIFT_ALREADY_EXISTS":
      return ErrorCode.ERROR_CODE_SHIFT_ALREADY_EXISTS;
    case 501:
    case "ERROR_CODE_CREATION_NOT_ALLOWED":
      return ErrorCode.ERROR_CODE_CREATION_NOT_ALLOWED;
    case 502:
    case "ERROR_CODE_CREATE_ISSUE":
      return ErrorCode.ERROR_CODE_CREATE_ISSUE;
    case 503:
    case "ERROR_CODE_DUPLICATE_PHONE_NUMBER":
      return ErrorCode.ERROR_CODE_DUPLICATE_PHONE_NUMBER;
    case 504:
    case "ERROR_CODE_DUPLICATE_EMAIL":
      return ErrorCode.ERROR_CODE_DUPLICATE_EMAIL;
    case 505:
    case "ERROR_CODE_ALREADY_EXISTS":
      return ErrorCode.ERROR_CODE_ALREADY_EXISTS;
    case 506:
    case "ERROR_CODE_CREATION_FAILED":
      return ErrorCode.ERROR_CODE_CREATION_FAILED;
    case 601:
    case "ERROR_CODE_UPDATE_NOT_ALLOWED":
      return ErrorCode.ERROR_CODE_UPDATE_NOT_ALLOWED;
    case 602:
    case "ERROR_CODE_UPDATE_FAILED":
      return ErrorCode.ERROR_CODE_UPDATE_FAILED;
    case 603:
    case "ERROR_CODE_UPDATE_INVALID":
      return ErrorCode.ERROR_CODE_UPDATE_INVALID;
    case 701:
    case "ERROR_CODE_DELETION_NOT_ALLOWED":
      return ErrorCode.ERROR_CODE_DELETION_NOT_ALLOWED;
    case 702:
    case "ERROR_CODE_DELETION_FAILED":
      return ErrorCode.ERROR_CODE_DELETION_FAILED;
    case 703:
    case "ERROR_CODE_DELETION_INVALID":
      return ErrorCode.ERROR_CODE_DELETION_INVALID;
    case 801:
    case "ERROR_CODE_GORM_TO_PROTO_CONVERSION":
      return ErrorCode.ERROR_CODE_GORM_TO_PROTO_CONVERSION;
    case 802:
    case "ERROR_CODE_PROTO_TO_GORM_CONVERSION":
      return ErrorCode.ERROR_CODE_PROTO_TO_GORM_CONVERSION;
    case 803:
    case "ERROR_CODE_DATA_MARSHALING_FAILED":
      return ErrorCode.ERROR_CODE_DATA_MARSHALING_FAILED;
    case 804:
    case "ERROR_CODE_INTERNAL":
      return ErrorCode.ERROR_CODE_INTERNAL;
    case 901:
    case "ERROR_CODE_PERMIFY_ISSUE":
      return ErrorCode.ERROR_CODE_PERMIFY_ISSUE;
    case 902:
    case "ERROR_CODE_STORAGE_SERVICE_ISSUE":
      return ErrorCode.ERROR_CODE_STORAGE_SERVICE_ISSUE;
    case 903:
    case "ERROR_CODE_WHATSAPP_SENDING_ISSUE":
      return ErrorCode.ERROR_CODE_WHATSAPP_SENDING_ISSUE;
    case 904:
    case "ERROR_CODE_EMAIL_SENDING_ISSUE":
      return ErrorCode.ERROR_CODE_EMAIL_SENDING_ISSUE;
    case 905:
    case "ERROR_CODE_DATABASE_ISSUE":
      return ErrorCode.ERROR_CODE_DATABASE_ISSUE;
    case 906:
    case "ERROR_CODE_NOSQL_DATABASE_ISSUE":
      return ErrorCode.ERROR_CODE_NOSQL_DATABASE_ISSUE;
    case 907:
    case "ERROR_CODE_VRP_SERVICE_ISSUE":
      return ErrorCode.ERROR_CODE_VRP_SERVICE_ISSUE;
    case 908:
    case "ERROR_CODE_COST_PROVIDER_ISSUE":
      return ErrorCode.ERROR_CODE_COST_PROVIDER_ISSUE;
    case 909:
    case "ERROR_CODE_VOXIMPLANT_ISSUE":
      return ErrorCode.ERROR_CODE_VOXIMPLANT_ISSUE;
    case 910:
    case "ERROR_CODE_ENCRYPTION_FAILED":
      return ErrorCode.ERROR_CODE_ENCRYPTION_FAILED;
    case 911:
    case "ERROR_CODE_DECRYPTION_FAILED":
      return ErrorCode.ERROR_CODE_DECRYPTION_FAILED;
    case 1001:
    case "ERROR_CODE_ROUTE_FINAL":
      return ErrorCode.ERROR_CODE_ROUTE_FINAL;
    case 1002:
    case "ERROR_CODE_ROUTE_NOT_RETURNING":
      return ErrorCode.ERROR_CODE_ROUTE_NOT_RETURNING;
    case 1003:
    case "ERROR_CODE_ROUTE_INVALID_TRANSITION":
      return ErrorCode.ERROR_CODE_ROUTE_INVALID_TRANSITION;
    case 1004:
    case "ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT":
      return ErrorCode.ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT;
    case 1005:
    case "ERROR_CODE_ROUTE_NOT_APPROVABLE":
      return ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVABLE;
    case 1006:
    case "ERROR_CODE_ROUTE_NOT_APPROVED":
      return ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVED;
    case 1007:
    case "ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED":
      return ErrorCode.ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED;
    case 1008:
    case "ERROR_CODE_ROUTE_NO_DESTINATION":
      return ErrorCode.ERROR_CODE_ROUTE_NO_DESTINATION;
    case 1009:
    case "ERROR_CODE_ROUTE_NOT_DISSOLVABLE":
      return ErrorCode.ERROR_CODE_ROUTE_NOT_DISSOLVABLE;
    case 1010:
    case "ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION":
      return ErrorCode.ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION;
    case 1011:
    case "ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS":
      return ErrorCode.ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS;
    case 1012:
    case "ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE":
      return ErrorCode.ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE;
    case 1013:
    case "ERROR_CODE_ROUTE_DURATION_TOO_SHORT":
      return ErrorCode.ERROR_CODE_ROUTE_DURATION_TOO_SHORT;
    case 1014:
    case "ERROR_CODE_ROUTE_STOP_AMBIGUOUS":
      return ErrorCode.ERROR_CODE_ROUTE_STOP_AMBIGUOUS;
    case 1015:
    case "ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB":
      return ErrorCode.ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB;
    case 1016:
    case "ERROR_CODE_ROUTE_RETURNING":
      return ErrorCode.ERROR_CODE_ROUTE_RETURNING;
    case 1017:
    case "ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE":
      return ErrorCode.ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE;
    case 1101:
    case "ERROR_CODE_JOB_NOT_IN_ROUTE":
      return ErrorCode.ERROR_CODE_JOB_NOT_IN_ROUTE;
    case 1102:
    case "ERROR_CODE_JOB_ALREADY_ON_SERVICE":
      return ErrorCode.ERROR_CODE_JOB_ALREADY_ON_SERVICE;
    case 1103:
    case "ERROR_CODE_JOB_NOT_ON_SERVICE":
      return ErrorCode.ERROR_CODE_JOB_NOT_ON_SERVICE;
    case 1104:
    case "ERROR_CODE_JOB_FINAL":
      return ErrorCode.ERROR_CODE_JOB_FINAL;
    case 1105:
    case "ERROR_CODE_JOB_NOT_DETACHABLE":
      return ErrorCode.ERROR_CODE_JOB_NOT_DETACHABLE;
    case 1106:
    case "ERROR_CODE_JOB_INVALID_TRANSITION":
      return ErrorCode.ERROR_CODE_JOB_INVALID_TRANSITION;
    case 1107:
    case "ERROR_CODE_JOB_NOT_ENROUTE":
      return ErrorCode.ERROR_CODE_JOB_NOT_ENROUTE;
    case 1108:
    case "ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT":
      return ErrorCode.ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT;
    case 1109:
    case "ERROR_CODE_JOB_NOT_COMPLETED":
      return ErrorCode.ERROR_CODE_JOB_NOT_COMPLETED;
    case 1110:
    case "ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE":
      return ErrorCode.ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE;
    case 1111:
    case "ERROR_CODE_JOB_LIST_CONFLICT":
      return ErrorCode.ERROR_CODE_JOB_LIST_CONFLICT;
    case 1112:
    case "ERROR_CODE_JOB_NOT_LISTED":
      return ErrorCode.ERROR_CODE_JOB_NOT_LISTED;
    case 1113:
    case "ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY":
      return ErrorCode.ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY;
    case 1114:
    case "ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH":
      return ErrorCode.ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH;
    case 1115:
    case "ERROR_CODE_JOB_HAS_NO_ROUTE":
      return ErrorCode.ERROR_CODE_JOB_HAS_NO_ROUTE;
    case 1116:
    case "ERROR_CODE_JOB_ALREADY_ASSIGNED":
      return ErrorCode.ERROR_CODE_JOB_ALREADY_ASSIGNED;
    case 1117:
    case "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE":
      return ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE;
    case 1118:
    case "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE":
      return ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE;
    case 1201:
    case "ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE;
    case 1202:
    case "ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER;
    case 1203:
    case "ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY;
    case 1204:
    case "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY;
    case 1205:
    case "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT;
    case 1206:
    case "ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION;
    case 1207:
    case "ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED;
    case 1208:
    case "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE;
    case 1209:
    case "ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK;
    case 1210:
    case "ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE;
    case 1211:
    case "ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT;
    case 1212:
    case "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE;
    case 1213:
    case "ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED":
      return ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED;
    case 1301:
    case "ERROR_CODE_TRUCK_JOB_LIMIT":
      return ErrorCode.ERROR_CODE_TRUCK_JOB_LIMIT;
    case 1302:
    case "ERROR_CODE_TRUCK_JOB_INCOMPATIBLE":
      return ErrorCode.ERROR_CODE_TRUCK_JOB_INCOMPATIBLE;
    case 1303:
    case "ERROR_CODE_TRUCK_NO_DEPOT":
      return ErrorCode.ERROR_CODE_TRUCK_NO_DEPOT;
    case 1304:
    case "ERROR_CODE_TRUCK_NO_TYPE":
      return ErrorCode.ERROR_CODE_TRUCK_NO_TYPE;
    case 1305:
    case "ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET":
      return ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET;
    case 1306:
    case "ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET":
      return ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET;
    case 1307:
    case "ERROR_CODE_TRUCK_NOT_ACTIVE":
      return ErrorCode.ERROR_CODE_TRUCK_NOT_ACTIVE;
    case 1401:
    case "ERROR_CODE_CONTAINER_GROUP_NOT_BOUND":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_NOT_BOUND;
    case 1402:
    case "ERROR_CODE_CONTRACT_PARTIES_MISMATCH":
      return ErrorCode.ERROR_CODE_CONTRACT_PARTIES_MISMATCH;
    case 1403:
    case "ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE;
    case 1404:
    case "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY;
    case 1405:
    case "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE;
    case 1406:
    case "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING;
    case 1407:
    case "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP;
    case 1408:
    case "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES;
    case 1409:
    case "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD;
    case 1410:
    case "ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE":
      return ErrorCode.ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE;
    case 1501:
    case "ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE;
    case 1502:
    case "ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT;
    case 1503:
    case "ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED;
    case 1504:
    case "ERROR_CODE_PICKUP_LOCATION_TOO_FAR":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_TOO_FAR;
    case 1505:
    case "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK;
    case 1506:
    case "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS":
      return ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS;
    case 1601:
    case "ERROR_CODE_ORGANIZATION_MISMATCH":
      return ErrorCode.ERROR_CODE_ORGANIZATION_MISMATCH;
    case 1602:
    case "ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER;
    case 1603:
    case "ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER;
    case 1604:
    case "ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS;
    case 1605:
    case "ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE;
    case 1606:
    case "ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER;
    case 1607:
    case "ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT":
      return ErrorCode.ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT;
    case 1608:
    case "ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS":
      return ErrorCode.ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS;
    case 1609:
    case "ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH":
      return ErrorCode.ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH;
    case 1701:
    case "ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION":
      return ErrorCode.ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION;
    case 1801:
    case "ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE":
      return ErrorCode.ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE;
    case 1802:
    case "ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER":
      return ErrorCode.ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER;
    case 1901:
    case "ERROR_CODE_CONTACT_NO_PHONE_NUMBER":
      return ErrorCode.ERROR_CODE_CONTACT_NO_PHONE_NUMBER;
    case 2001:
    case "ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED":
      return ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED;
    case 2002:
    case "ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY":
      return ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY;
    case 2003:
    case "ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED":
      return ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED;
    case 2004:
    case "ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE":
      return ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE;
    case 2101:
    case "ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE":
      return ErrorCode.ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE;
    case 2201:
    case "ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED":
      return ErrorCode.ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED;
    case 2301:
    case "ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN":
      return ErrorCode.ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN;
    case 2401:
    case "ERROR_CODE_TYPE_OUTSIDE_HOLDING":
      return ErrorCode.ERROR_CODE_TYPE_OUTSIDE_HOLDING;
    case 2402:
    case "ERROR_CODE_TYPE_NOT_OWNED":
      return ErrorCode.ERROR_CODE_TYPE_NOT_OWNED;
    case 2403:
    case "ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING":
      return ErrorCode.ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING;
    case 2404:
    case "ERROR_CODE_TRUCK_TYPE_IN_USE":
      return ErrorCode.ERROR_CODE_TRUCK_TYPE_IN_USE;
    case 9001:
    case "ERROR_CODE_COMPANY_NOT_SELECTED":
      return ErrorCode.ERROR_CODE_COMPANY_NOT_SELECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.ERROR_CODE_UNDEFINED:
      return "ERROR_CODE_UNDEFINED";
    case ErrorCode.ERROR_CODE_AUTH_HEADER_ISSUE:
      return "ERROR_CODE_AUTH_HEADER_ISSUE";
    case ErrorCode.ERROR_CODE_AUTH_TOKEN_ISSUE:
      return "ERROR_CODE_AUTH_TOKEN_ISSUE";
    case ErrorCode.ERROR_CODE_AUTH_TOKEN_INVALID:
      return "ERROR_CODE_AUTH_TOKEN_INVALID";
    case ErrorCode.ERROR_CODE_AUTH_MISSING_CTX:
      return "ERROR_CODE_AUTH_MISSING_CTX";
    case ErrorCode.ERROR_CODE_INVALID_CREDENTIALS:
      return "ERROR_CODE_INVALID_CREDENTIALS";
    case ErrorCode.ERROR_CODE_AUTH_EXPIRED:
      return "ERROR_CODE_AUTH_EXPIRED";
    case ErrorCode.ERROR_CODE_AUTH_INVALID_USER_DATA:
      return "ERROR_CODE_AUTH_INVALID_USER_DATA";
    case ErrorCode.ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED:
      return "ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED";
    case ErrorCode.ERROR_CODE_OTP_SERVICE_ISSUE:
      return "ERROR_CODE_OTP_SERVICE_ISSUE";
    case ErrorCode.ERROR_CODE_OTP_INVALID:
      return "ERROR_CODE_OTP_INVALID";
    case ErrorCode.ERROR_CODE_OTP_EXPIRED:
      return "ERROR_CODE_OTP_EXPIRED";
    case ErrorCode.ERROR_CODE_OTP_RATE_LIMIT:
      return "ERROR_CODE_OTP_RATE_LIMIT";
    case ErrorCode.ERROR_CODE_PASSWORD_RESET_ISSUE:
      return "ERROR_CODE_PASSWORD_RESET_ISSUE";
    case ErrorCode.ERROR_CODE_OTP_EMAIL_REQUIRED:
      return "ERROR_CODE_OTP_EMAIL_REQUIRED";
    case ErrorCode.ERROR_CODE_OTP_PHONE_REQUIRED:
      return "ERROR_CODE_OTP_PHONE_REQUIRED";
    case ErrorCode.ERROR_CODE_USER_INACTIVE:
      return "ERROR_CODE_USER_INACTIVE";
    case ErrorCode.ERROR_CODE_REFRESH_TOKEN_INVALID:
      return "ERROR_CODE_REFRESH_TOKEN_INVALID";
    case ErrorCode.ERROR_CODE_REFRESH_TOKEN_EXPIRED:
      return "ERROR_CODE_REFRESH_TOKEN_EXPIRED";
    case ErrorCode.ERROR_CODE_SESSION_REVOKED:
      return "ERROR_CODE_SESSION_REVOKED";
    case ErrorCode.ERROR_CODE_PERMISSION_DENIED:
      return "ERROR_CODE_PERMISSION_DENIED";
    case ErrorCode.ERROR_CODE_NO_ACCESS:
      return "ERROR_CODE_NO_ACCESS";
    case ErrorCode.ERROR_CODE_INVALID_PERMISSION_REQUEST:
      return "ERROR_CODE_INVALID_PERMISSION_REQUEST";
    case ErrorCode.ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED:
      return "ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED";
    case ErrorCode.ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED:
      return "ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED";
    case ErrorCode.ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED:
      return "ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED";
    case ErrorCode.ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED:
      return "ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED";
    case ErrorCode.ERROR_CODE_GRANT_OPERATION_FAILED:
      return "ERROR_CODE_GRANT_OPERATION_FAILED";
    case ErrorCode.ERROR_CODE_MEMBERSHIP_OPERATION_FAILED:
      return "ERROR_CODE_MEMBERSHIP_OPERATION_FAILED";
    case ErrorCode.ERROR_CODE_ADMIN_ACTION_REQUIRED:
      return "ERROR_CODE_ADMIN_ACTION_REQUIRED";
    case ErrorCode.ERROR_CODE_UNDEFINED_ROLE:
      return "ERROR_CODE_UNDEFINED_ROLE";
    case ErrorCode.ERROR_CODE_ROLE_NOT_ALLOWED:
      return "ERROR_CODE_ROLE_NOT_ALLOWED";
    case ErrorCode.ERROR_CODE_REQUIRED_FIELD_MISSING:
      return "ERROR_CODE_REQUIRED_FIELD_MISSING";
    case ErrorCode.ERROR_CODE_INVALID_FIELD_VALUE:
      return "ERROR_CODE_INVALID_FIELD_VALUE";
    case ErrorCode.ERROR_CODE_DUPLICATE_ENTRY:
      return "ERROR_CODE_DUPLICATE_ENTRY";
    case ErrorCode.ERROR_CODE_INVALID_FORMAT:
      return "ERROR_CODE_INVALID_FORMAT";
    case ErrorCode.ERROR_CODE_VALUE_TOO_SHORT:
      return "ERROR_CODE_VALUE_TOO_SHORT";
    case ErrorCode.ERROR_CODE_VALUE_TOO_LONG:
      return "ERROR_CODE_VALUE_TOO_LONG";
    case ErrorCode.ERROR_CODE_OUT_OF_RANGE:
      return "ERROR_CODE_OUT_OF_RANGE";
    case ErrorCode.ERROR_CODE_FILE_REQUIRED:
      return "ERROR_CODE_FILE_REQUIRED";
    case ErrorCode.ERROR_CODE_FILTER_REQUIRED:
      return "ERROR_CODE_FILTER_REQUIRED";
    case ErrorCode.ERROR_CODE_FILTER_INVALID:
      return "ERROR_CODE_FILTER_INVALID";
    case ErrorCode.ERROR_CODE_INVALID_ENUM_VALUE:
      return "ERROR_CODE_INVALID_ENUM_VALUE";
    case ErrorCode.ERROR_CODE_INVALID_REQUEST_STATE:
      return "ERROR_CODE_INVALID_REQUEST_STATE";
    case ErrorCode.ERROR_CODE_ORGANIZATION_TYPE_MISMATCH:
      return "ERROR_CODE_ORGANIZATION_TYPE_MISMATCH";
    case ErrorCode.ERROR_CODE_INVALID_VALUE:
      return "ERROR_CODE_INVALID_VALUE";
    case ErrorCode.ERROR_CODE_CONTRACT_NOT_FOUND:
      return "ERROR_CODE_CONTRACT_NOT_FOUND";
    case ErrorCode.ERROR_CODE_CONTRACT_EXPIRED:
      return "ERROR_CODE_CONTRACT_EXPIRED";
    case ErrorCode.ERROR_CODE_CONTRACT_NOT_ACTIVE:
      return "ERROR_CODE_CONTRACT_NOT_ACTIVE";
    case ErrorCode.ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND:
      return "ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND";
    case ErrorCode.ERROR_CODE_FILE_INVALID_BASE64:
      return "ERROR_CODE_FILE_INVALID_BASE64";
    case ErrorCode.ERROR_CODE_FILE_UPLOAD_FAILED:
      return "ERROR_CODE_FILE_UPLOAD_FAILED";
    case ErrorCode.ERROR_CODE_FILE_TYPE_INVALID:
      return "ERROR_CODE_FILE_TYPE_INVALID";
    case ErrorCode.ERROR_CODE_NOT_FOUND:
      return "ERROR_CODE_NOT_FOUND";
    case ErrorCode.ERROR_CODE_MULTIPLE_FOUND:
      return "ERROR_CODE_MULTIPLE_FOUND";
    case ErrorCode.ERROR_CODE_INVALID_ID:
      return "ERROR_CODE_INVALID_ID";
    case ErrorCode.ERROR_CODE_INVALID_QUERY:
      return "ERROR_CODE_INVALID_QUERY";
    case ErrorCode.ERROR_CODE_RELATED_ENTITY_NOT_FOUND:
      return "ERROR_CODE_RELATED_ENTITY_NOT_FOUND";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_FOUND:
      return "ERROR_CODE_ORGANIZATION_NOT_FOUND";
    case ErrorCode.ERROR_CODE_CONTAINER_TYPE_NOT_FOUND:
      return "ERROR_CODE_CONTAINER_TYPE_NOT_FOUND";
    case ErrorCode.ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER:
      return "ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER";
    case ErrorCode.ERROR_CODE_LOOKUP_FAILED:
      return "ERROR_CODE_LOOKUP_FAILED";
    case ErrorCode.ERROR_CODE_SHIFT_ALREADY_EXISTS:
      return "ERROR_CODE_SHIFT_ALREADY_EXISTS";
    case ErrorCode.ERROR_CODE_CREATION_NOT_ALLOWED:
      return "ERROR_CODE_CREATION_NOT_ALLOWED";
    case ErrorCode.ERROR_CODE_CREATE_ISSUE:
      return "ERROR_CODE_CREATE_ISSUE";
    case ErrorCode.ERROR_CODE_DUPLICATE_PHONE_NUMBER:
      return "ERROR_CODE_DUPLICATE_PHONE_NUMBER";
    case ErrorCode.ERROR_CODE_DUPLICATE_EMAIL:
      return "ERROR_CODE_DUPLICATE_EMAIL";
    case ErrorCode.ERROR_CODE_ALREADY_EXISTS:
      return "ERROR_CODE_ALREADY_EXISTS";
    case ErrorCode.ERROR_CODE_CREATION_FAILED:
      return "ERROR_CODE_CREATION_FAILED";
    case ErrorCode.ERROR_CODE_UPDATE_NOT_ALLOWED:
      return "ERROR_CODE_UPDATE_NOT_ALLOWED";
    case ErrorCode.ERROR_CODE_UPDATE_FAILED:
      return "ERROR_CODE_UPDATE_FAILED";
    case ErrorCode.ERROR_CODE_UPDATE_INVALID:
      return "ERROR_CODE_UPDATE_INVALID";
    case ErrorCode.ERROR_CODE_DELETION_NOT_ALLOWED:
      return "ERROR_CODE_DELETION_NOT_ALLOWED";
    case ErrorCode.ERROR_CODE_DELETION_FAILED:
      return "ERROR_CODE_DELETION_FAILED";
    case ErrorCode.ERROR_CODE_DELETION_INVALID:
      return "ERROR_CODE_DELETION_INVALID";
    case ErrorCode.ERROR_CODE_GORM_TO_PROTO_CONVERSION:
      return "ERROR_CODE_GORM_TO_PROTO_CONVERSION";
    case ErrorCode.ERROR_CODE_PROTO_TO_GORM_CONVERSION:
      return "ERROR_CODE_PROTO_TO_GORM_CONVERSION";
    case ErrorCode.ERROR_CODE_DATA_MARSHALING_FAILED:
      return "ERROR_CODE_DATA_MARSHALING_FAILED";
    case ErrorCode.ERROR_CODE_INTERNAL:
      return "ERROR_CODE_INTERNAL";
    case ErrorCode.ERROR_CODE_PERMIFY_ISSUE:
      return "ERROR_CODE_PERMIFY_ISSUE";
    case ErrorCode.ERROR_CODE_STORAGE_SERVICE_ISSUE:
      return "ERROR_CODE_STORAGE_SERVICE_ISSUE";
    case ErrorCode.ERROR_CODE_WHATSAPP_SENDING_ISSUE:
      return "ERROR_CODE_WHATSAPP_SENDING_ISSUE";
    case ErrorCode.ERROR_CODE_EMAIL_SENDING_ISSUE:
      return "ERROR_CODE_EMAIL_SENDING_ISSUE";
    case ErrorCode.ERROR_CODE_DATABASE_ISSUE:
      return "ERROR_CODE_DATABASE_ISSUE";
    case ErrorCode.ERROR_CODE_NOSQL_DATABASE_ISSUE:
      return "ERROR_CODE_NOSQL_DATABASE_ISSUE";
    case ErrorCode.ERROR_CODE_VRP_SERVICE_ISSUE:
      return "ERROR_CODE_VRP_SERVICE_ISSUE";
    case ErrorCode.ERROR_CODE_COST_PROVIDER_ISSUE:
      return "ERROR_CODE_COST_PROVIDER_ISSUE";
    case ErrorCode.ERROR_CODE_VOXIMPLANT_ISSUE:
      return "ERROR_CODE_VOXIMPLANT_ISSUE";
    case ErrorCode.ERROR_CODE_ENCRYPTION_FAILED:
      return "ERROR_CODE_ENCRYPTION_FAILED";
    case ErrorCode.ERROR_CODE_DECRYPTION_FAILED:
      return "ERROR_CODE_DECRYPTION_FAILED";
    case ErrorCode.ERROR_CODE_ROUTE_FINAL:
      return "ERROR_CODE_ROUTE_FINAL";
    case ErrorCode.ERROR_CODE_ROUTE_NOT_RETURNING:
      return "ERROR_CODE_ROUTE_NOT_RETURNING";
    case ErrorCode.ERROR_CODE_ROUTE_INVALID_TRANSITION:
      return "ERROR_CODE_ROUTE_INVALID_TRANSITION";
    case ErrorCode.ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT:
      return "ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT";
    case ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVABLE:
      return "ERROR_CODE_ROUTE_NOT_APPROVABLE";
    case ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVED:
      return "ERROR_CODE_ROUTE_NOT_APPROVED";
    case ErrorCode.ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED:
      return "ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED";
    case ErrorCode.ERROR_CODE_ROUTE_NO_DESTINATION:
      return "ERROR_CODE_ROUTE_NO_DESTINATION";
    case ErrorCode.ERROR_CODE_ROUTE_NOT_DISSOLVABLE:
      return "ERROR_CODE_ROUTE_NOT_DISSOLVABLE";
    case ErrorCode.ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION:
      return "ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION";
    case ErrorCode.ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS:
      return "ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS";
    case ErrorCode.ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE:
      return "ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE";
    case ErrorCode.ERROR_CODE_ROUTE_DURATION_TOO_SHORT:
      return "ERROR_CODE_ROUTE_DURATION_TOO_SHORT";
    case ErrorCode.ERROR_CODE_ROUTE_STOP_AMBIGUOUS:
      return "ERROR_CODE_ROUTE_STOP_AMBIGUOUS";
    case ErrorCode.ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB:
      return "ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB";
    case ErrorCode.ERROR_CODE_ROUTE_RETURNING:
      return "ERROR_CODE_ROUTE_RETURNING";
    case ErrorCode.ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE:
      return "ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE";
    case ErrorCode.ERROR_CODE_JOB_NOT_IN_ROUTE:
      return "ERROR_CODE_JOB_NOT_IN_ROUTE";
    case ErrorCode.ERROR_CODE_JOB_ALREADY_ON_SERVICE:
      return "ERROR_CODE_JOB_ALREADY_ON_SERVICE";
    case ErrorCode.ERROR_CODE_JOB_NOT_ON_SERVICE:
      return "ERROR_CODE_JOB_NOT_ON_SERVICE";
    case ErrorCode.ERROR_CODE_JOB_FINAL:
      return "ERROR_CODE_JOB_FINAL";
    case ErrorCode.ERROR_CODE_JOB_NOT_DETACHABLE:
      return "ERROR_CODE_JOB_NOT_DETACHABLE";
    case ErrorCode.ERROR_CODE_JOB_INVALID_TRANSITION:
      return "ERROR_CODE_JOB_INVALID_TRANSITION";
    case ErrorCode.ERROR_CODE_JOB_NOT_ENROUTE:
      return "ERROR_CODE_JOB_NOT_ENROUTE";
    case ErrorCode.ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT:
      return "ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT";
    case ErrorCode.ERROR_CODE_JOB_NOT_COMPLETED:
      return "ERROR_CODE_JOB_NOT_COMPLETED";
    case ErrorCode.ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE:
      return "ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE";
    case ErrorCode.ERROR_CODE_JOB_LIST_CONFLICT:
      return "ERROR_CODE_JOB_LIST_CONFLICT";
    case ErrorCode.ERROR_CODE_JOB_NOT_LISTED:
      return "ERROR_CODE_JOB_NOT_LISTED";
    case ErrorCode.ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY:
      return "ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY";
    case ErrorCode.ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH:
      return "ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH";
    case ErrorCode.ERROR_CODE_JOB_HAS_NO_ROUTE:
      return "ERROR_CODE_JOB_HAS_NO_ROUTE";
    case ErrorCode.ERROR_CODE_JOB_ALREADY_ASSIGNED:
      return "ERROR_CODE_JOB_ALREADY_ASSIGNED";
    case ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE:
      return "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE";
    case ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE:
      return "ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE:
      return "ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER:
      return "ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY:
      return "ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY:
      return "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT:
      return "ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION:
      return "ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED:
      return "ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE:
      return "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK:
      return "ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE:
      return "ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT:
      return "ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE:
      return "ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE";
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED:
      return "ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED";
    case ErrorCode.ERROR_CODE_TRUCK_JOB_LIMIT:
      return "ERROR_CODE_TRUCK_JOB_LIMIT";
    case ErrorCode.ERROR_CODE_TRUCK_JOB_INCOMPATIBLE:
      return "ERROR_CODE_TRUCK_JOB_INCOMPATIBLE";
    case ErrorCode.ERROR_CODE_TRUCK_NO_DEPOT:
      return "ERROR_CODE_TRUCK_NO_DEPOT";
    case ErrorCode.ERROR_CODE_TRUCK_NO_TYPE:
      return "ERROR_CODE_TRUCK_NO_TYPE";
    case ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET:
      return "ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET";
    case ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET:
      return "ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET";
    case ErrorCode.ERROR_CODE_TRUCK_NOT_ACTIVE:
      return "ERROR_CODE_TRUCK_NOT_ACTIVE";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_NOT_BOUND:
      return "ERROR_CODE_CONTAINER_GROUP_NOT_BOUND";
    case ErrorCode.ERROR_CODE_CONTRACT_PARTIES_MISMATCH:
      return "ERROR_CODE_CONTRACT_PARTIES_MISMATCH";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE:
      return "ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY:
      return "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE:
      return "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING:
      return "ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP:
      return "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES:
      return "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD:
      return "ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD";
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE:
      return "ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE:
      return "ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT:
      return "ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED:
      return "ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_TOO_FAR:
      return "ERROR_CODE_PICKUP_LOCATION_TOO_FAR";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK:
      return "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK";
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS:
      return "ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS";
    case ErrorCode.ERROR_CODE_ORGANIZATION_MISMATCH:
      return "ERROR_CODE_ORGANIZATION_MISMATCH";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER:
      return "ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER:
      return "ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS:
      return "ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE:
      return "ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER:
      return "ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER";
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT:
      return "ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT";
    case ErrorCode.ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS:
      return "ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS";
    case ErrorCode.ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH:
      return "ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH";
    case ErrorCode.ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION:
      return "ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION";
    case ErrorCode.ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE:
      return "ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE";
    case ErrorCode.ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER:
      return "ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER";
    case ErrorCode.ERROR_CODE_CONTACT_NO_PHONE_NUMBER:
      return "ERROR_CODE_CONTACT_NO_PHONE_NUMBER";
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED:
      return "ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED";
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY:
      return "ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY";
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED:
      return "ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED";
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE:
      return "ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE";
    case ErrorCode.ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE:
      return "ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE";
    case ErrorCode.ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED:
      return "ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED";
    case ErrorCode.ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN:
      return "ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN";
    case ErrorCode.ERROR_CODE_TYPE_OUTSIDE_HOLDING:
      return "ERROR_CODE_TYPE_OUTSIDE_HOLDING";
    case ErrorCode.ERROR_CODE_TYPE_NOT_OWNED:
      return "ERROR_CODE_TYPE_NOT_OWNED";
    case ErrorCode.ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING:
      return "ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING";
    case ErrorCode.ERROR_CODE_TRUCK_TYPE_IN_USE:
      return "ERROR_CODE_TRUCK_TYPE_IN_USE";
    case ErrorCode.ERROR_CODE_COMPANY_NOT_SELECTED:
      return "ERROR_CODE_COMPANY_NOT_SELECTED";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function errorCodeToNumber(object: ErrorCode): number {
  switch (object) {
    case ErrorCode.ERROR_CODE_UNDEFINED:
      return 0;
    case ErrorCode.ERROR_CODE_AUTH_HEADER_ISSUE:
      return 101;
    case ErrorCode.ERROR_CODE_AUTH_TOKEN_ISSUE:
      return 102;
    case ErrorCode.ERROR_CODE_AUTH_TOKEN_INVALID:
      return 103;
    case ErrorCode.ERROR_CODE_AUTH_MISSING_CTX:
      return 104;
    case ErrorCode.ERROR_CODE_INVALID_CREDENTIALS:
      return 105;
    case ErrorCode.ERROR_CODE_AUTH_EXPIRED:
      return 106;
    case ErrorCode.ERROR_CODE_AUTH_INVALID_USER_DATA:
      return 107;
    case ErrorCode.ERROR_CODE_NO_PHONE_OR_EMAIL_PROVIDED:
      return 108;
    case ErrorCode.ERROR_CODE_OTP_SERVICE_ISSUE:
      return 109;
    case ErrorCode.ERROR_CODE_OTP_INVALID:
      return 110;
    case ErrorCode.ERROR_CODE_OTP_EXPIRED:
      return 111;
    case ErrorCode.ERROR_CODE_OTP_RATE_LIMIT:
      return 112;
    case ErrorCode.ERROR_CODE_PASSWORD_RESET_ISSUE:
      return 113;
    case ErrorCode.ERROR_CODE_OTP_EMAIL_REQUIRED:
      return 114;
    case ErrorCode.ERROR_CODE_OTP_PHONE_REQUIRED:
      return 115;
    case ErrorCode.ERROR_CODE_USER_INACTIVE:
      return 116;
    case ErrorCode.ERROR_CODE_REFRESH_TOKEN_INVALID:
      return 117;
    case ErrorCode.ERROR_CODE_REFRESH_TOKEN_EXPIRED:
      return 118;
    case ErrorCode.ERROR_CODE_SESSION_REVOKED:
      return 119;
    case ErrorCode.ERROR_CODE_PERMISSION_DENIED:
      return 201;
    case ErrorCode.ERROR_CODE_NO_ACCESS:
      return 202;
    case ErrorCode.ERROR_CODE_INVALID_PERMISSION_REQUEST:
      return 203;
    case ErrorCode.ERROR_CODE_OWNER_ORGANIZATION_LIST_REQUIRED:
      return 204;
    case ErrorCode.ERROR_CODE_SERVICE_PROVIDER_LIST_REQUIRED:
      return 205;
    case ErrorCode.ERROR_CODE_SERVICE_RECEIVER_LIST_REQUIRED:
      return 206;
    case ErrorCode.ERROR_CODE_TARGET_ORGANIZATION_LIST_REQUIRED:
      return 207;
    case ErrorCode.ERROR_CODE_GRANT_OPERATION_FAILED:
      return 211;
    case ErrorCode.ERROR_CODE_MEMBERSHIP_OPERATION_FAILED:
      return 212;
    case ErrorCode.ERROR_CODE_ADMIN_ACTION_REQUIRED:
      return 213;
    case ErrorCode.ERROR_CODE_UNDEFINED_ROLE:
      return 220;
    case ErrorCode.ERROR_CODE_ROLE_NOT_ALLOWED:
      return 221;
    case ErrorCode.ERROR_CODE_REQUIRED_FIELD_MISSING:
      return 301;
    case ErrorCode.ERROR_CODE_INVALID_FIELD_VALUE:
      return 302;
    case ErrorCode.ERROR_CODE_DUPLICATE_ENTRY:
      return 303;
    case ErrorCode.ERROR_CODE_INVALID_FORMAT:
      return 304;
    case ErrorCode.ERROR_CODE_VALUE_TOO_SHORT:
      return 305;
    case ErrorCode.ERROR_CODE_VALUE_TOO_LONG:
      return 306;
    case ErrorCode.ERROR_CODE_OUT_OF_RANGE:
      return 307;
    case ErrorCode.ERROR_CODE_FILE_REQUIRED:
      return 308;
    case ErrorCode.ERROR_CODE_FILTER_REQUIRED:
      return 309;
    case ErrorCode.ERROR_CODE_FILTER_INVALID:
      return 310;
    case ErrorCode.ERROR_CODE_INVALID_ENUM_VALUE:
      return 311;
    case ErrorCode.ERROR_CODE_INVALID_REQUEST_STATE:
      return 312;
    case ErrorCode.ERROR_CODE_ORGANIZATION_TYPE_MISMATCH:
      return 313;
    case ErrorCode.ERROR_CODE_INVALID_VALUE:
      return 314;
    case ErrorCode.ERROR_CODE_CONTRACT_NOT_FOUND:
      return 330;
    case ErrorCode.ERROR_CODE_CONTRACT_EXPIRED:
      return 331;
    case ErrorCode.ERROR_CODE_CONTRACT_NOT_ACTIVE:
      return 332;
    case ErrorCode.ERROR_CODE_CONTRACT_JOB_TARIFF_NOT_FOUND:
      return 333;
    case ErrorCode.ERROR_CODE_FILE_INVALID_BASE64:
      return 320;
    case ErrorCode.ERROR_CODE_FILE_UPLOAD_FAILED:
      return 321;
    case ErrorCode.ERROR_CODE_FILE_TYPE_INVALID:
      return 322;
    case ErrorCode.ERROR_CODE_NOT_FOUND:
      return 401;
    case ErrorCode.ERROR_CODE_MULTIPLE_FOUND:
      return 402;
    case ErrorCode.ERROR_CODE_INVALID_ID:
      return 403;
    case ErrorCode.ERROR_CODE_INVALID_QUERY:
      return 404;
    case ErrorCode.ERROR_CODE_RELATED_ENTITY_NOT_FOUND:
      return 405;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_FOUND:
      return 406;
    case ErrorCode.ERROR_CODE_CONTAINER_TYPE_NOT_FOUND:
      return 407;
    case ErrorCode.ERROR_CODE_NO_ACTIVE_ROUTE_FOR_DRIVER:
      return 408;
    case ErrorCode.ERROR_CODE_LOOKUP_FAILED:
      return 409;
    case ErrorCode.ERROR_CODE_SHIFT_ALREADY_EXISTS:
      return 410;
    case ErrorCode.ERROR_CODE_CREATION_NOT_ALLOWED:
      return 501;
    case ErrorCode.ERROR_CODE_CREATE_ISSUE:
      return 502;
    case ErrorCode.ERROR_CODE_DUPLICATE_PHONE_NUMBER:
      return 503;
    case ErrorCode.ERROR_CODE_DUPLICATE_EMAIL:
      return 504;
    case ErrorCode.ERROR_CODE_ALREADY_EXISTS:
      return 505;
    case ErrorCode.ERROR_CODE_CREATION_FAILED:
      return 506;
    case ErrorCode.ERROR_CODE_UPDATE_NOT_ALLOWED:
      return 601;
    case ErrorCode.ERROR_CODE_UPDATE_FAILED:
      return 602;
    case ErrorCode.ERROR_CODE_UPDATE_INVALID:
      return 603;
    case ErrorCode.ERROR_CODE_DELETION_NOT_ALLOWED:
      return 701;
    case ErrorCode.ERROR_CODE_DELETION_FAILED:
      return 702;
    case ErrorCode.ERROR_CODE_DELETION_INVALID:
      return 703;
    case ErrorCode.ERROR_CODE_GORM_TO_PROTO_CONVERSION:
      return 801;
    case ErrorCode.ERROR_CODE_PROTO_TO_GORM_CONVERSION:
      return 802;
    case ErrorCode.ERROR_CODE_DATA_MARSHALING_FAILED:
      return 803;
    case ErrorCode.ERROR_CODE_INTERNAL:
      return 804;
    case ErrorCode.ERROR_CODE_PERMIFY_ISSUE:
      return 901;
    case ErrorCode.ERROR_CODE_STORAGE_SERVICE_ISSUE:
      return 902;
    case ErrorCode.ERROR_CODE_WHATSAPP_SENDING_ISSUE:
      return 903;
    case ErrorCode.ERROR_CODE_EMAIL_SENDING_ISSUE:
      return 904;
    case ErrorCode.ERROR_CODE_DATABASE_ISSUE:
      return 905;
    case ErrorCode.ERROR_CODE_NOSQL_DATABASE_ISSUE:
      return 906;
    case ErrorCode.ERROR_CODE_VRP_SERVICE_ISSUE:
      return 907;
    case ErrorCode.ERROR_CODE_COST_PROVIDER_ISSUE:
      return 908;
    case ErrorCode.ERROR_CODE_VOXIMPLANT_ISSUE:
      return 909;
    case ErrorCode.ERROR_CODE_ENCRYPTION_FAILED:
      return 910;
    case ErrorCode.ERROR_CODE_DECRYPTION_FAILED:
      return 911;
    case ErrorCode.ERROR_CODE_ROUTE_FINAL:
      return 1001;
    case ErrorCode.ERROR_CODE_ROUTE_NOT_RETURNING:
      return 1002;
    case ErrorCode.ERROR_CODE_ROUTE_INVALID_TRANSITION:
      return 1003;
    case ErrorCode.ERROR_CODE_ROUTE_NO_DRIVER_ON_SHIFT:
      return 1004;
    case ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVABLE:
      return 1005;
    case ErrorCode.ERROR_CODE_ROUTE_NOT_APPROVED:
      return 1006;
    case ErrorCode.ERROR_CODE_ROUTE_DRIVER_ON_SHIFT_CHANGE_NOT_ALLOWED:
      return 1007;
    case ErrorCode.ERROR_CODE_ROUTE_NO_DESTINATION:
      return 1008;
    case ErrorCode.ERROR_CODE_ROUTE_NOT_DISSOLVABLE:
      return 1009;
    case ErrorCode.ERROR_CODE_ROUTE_SAME_SOURCE_DESTINATION:
      return 1010;
    case ErrorCode.ERROR_CODE_ROUTE_ANOTHER_IN_PROGRESS:
      return 1011;
    case ErrorCode.ERROR_CODE_ROUTE_NO_JOB_ON_SERVICE:
      return 1012;
    case ErrorCode.ERROR_CODE_ROUTE_DURATION_TOO_SHORT:
      return 1013;
    case ErrorCode.ERROR_CODE_ROUTE_STOP_AMBIGUOUS:
      return 1014;
    case ErrorCode.ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB:
      return 1015;
    case ErrorCode.ERROR_CODE_ROUTE_RETURNING:
      return 1016;
    case ErrorCode.ERROR_CODE_ROUTE_OWNER_NOT_IN_ZONE:
      return 1017;
    case ErrorCode.ERROR_CODE_JOB_NOT_IN_ROUTE:
      return 1101;
    case ErrorCode.ERROR_CODE_JOB_ALREADY_ON_SERVICE:
      return 1102;
    case ErrorCode.ERROR_CODE_JOB_NOT_ON_SERVICE:
      return 1103;
    case ErrorCode.ERROR_CODE_JOB_FINAL:
      return 1104;
    case ErrorCode.ERROR_CODE_JOB_NOT_DETACHABLE:
      return 1105;
    case ErrorCode.ERROR_CODE_JOB_INVALID_TRANSITION:
      return 1106;
    case ErrorCode.ERROR_CODE_JOB_NOT_ENROUTE:
      return 1107;
    case ErrorCode.ERROR_CODE_JOB_NO_DRIVER_ON_SHIFT:
      return 1108;
    case ErrorCode.ERROR_CODE_JOB_NOT_COMPLETED:
      return 1109;
    case ErrorCode.ERROR_CODE_JOB_INSTRUCTIONS_NOT_EDITABLE:
      return 1110;
    case ErrorCode.ERROR_CODE_JOB_LIST_CONFLICT:
      return 1111;
    case ErrorCode.ERROR_CODE_JOB_NOT_LISTED:
      return 1112;
    case ErrorCode.ERROR_CODE_JOB_CATEGORY_NO_ROUTE_CATEGORY:
      return 1113;
    case ErrorCode.ERROR_CODE_JOB_ROUTE_CATEGORY_MISMATCH:
      return 1114;
    case ErrorCode.ERROR_CODE_JOB_HAS_NO_ROUTE:
      return 1115;
    case ErrorCode.ERROR_CODE_JOB_ALREADY_ASSIGNED:
      return 1116;
    case ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_IN_ZONE:
      return 1117;
    case ErrorCode.ERROR_CODE_JOB_SERVICE_PROVIDER_NOT_CHANGEABLE:
      return 1118;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_APPROVABLE:
      return 1201;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_DRIVER:
      return 1202;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TRUCK_BUSY:
      return 1203;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_BUSY:
      return 1204;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_DRIVER_CONFLICT:
      return 1205;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_INVALID_TRANSITION:
      return 1206;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_ROUTE_UNFINISHED:
      return 1207;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ASSIGNABLE:
      return 1208;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NO_TRUCK:
      return 1209;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_START_NOT_FUTURE:
      return 1210;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_TOO_SHORT:
      return 1211;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_NOT_ACTIVATABLE:
      return 1212;
    case ErrorCode.ERROR_CODE_DRIVER_ON_SHIFT_WINDOW_ENDED:
      return 1213;
    case ErrorCode.ERROR_CODE_TRUCK_JOB_LIMIT:
      return 1301;
    case ErrorCode.ERROR_CODE_TRUCK_JOB_INCOMPATIBLE:
      return 1302;
    case ErrorCode.ERROR_CODE_TRUCK_NO_DEPOT:
      return 1303;
    case ErrorCode.ERROR_CODE_TRUCK_NO_TYPE:
      return 1304;
    case ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_ALREADY_SET:
      return 1305;
    case ErrorCode.ERROR_CODE_TRUCK_ENGINE_TYPE_NOT_SET:
      return 1306;
    case ErrorCode.ERROR_CODE_TRUCK_NOT_ACTIVE:
      return 1307;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_NOT_BOUND:
      return 1401;
    case ErrorCode.ERROR_CODE_CONTRACT_PARTIES_MISMATCH:
      return 1402;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_NO_SCHEDULE:
      return 1403;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_NOT_COVERING_DAY:
      return 1404;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_IN_USE:
      return 1405;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SERVICE_PROVIDER_OUTSIDE_HOLDING:
      return 1406;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_OVERLAP:
      return 1407;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_RULES:
      return 1408;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_SCHEDULE_INVALID_PERIOD:
      return 1409;
    case ErrorCode.ERROR_CODE_CONTAINER_GROUP_ROUTE_GROUP_OUTSIDE_ZONE:
      return 1410;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_NOT_IN_ROUTE:
      return 1501;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_NO_JOB_LEFT:
      return 1502;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_ALREADY_SERVED:
      return 1503;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_TOO_FAR:
      return 1504;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK:
      return 1505;
    case ErrorCode.ERROR_CODE_PICKUP_LOCATION_GROUP_NO_CONTAINER_GROUPS:
      return 1506;
    case ErrorCode.ERROR_CODE_ORGANIZATION_MISMATCH:
      return 1601;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_PROVIDER:
      return 1602;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NOT_SERVICE_RECEIVER:
      return 1603;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_PRICING_SETTINGS:
      return 1604;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_HOURLY_RATE:
      return 1605;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_NIGHT_MULTIPLIER:
      return 1606;
    case ErrorCode.ERROR_CODE_ORGANIZATION_NO_ACTIVE_DEPOT:
      return 1607;
    case ErrorCode.ERROR_CODE_ORGANIZATION_MULTIPLE_ACTIVE_DEPOTS:
      return 1608;
    case ErrorCode.ERROR_CODE_ORGANIZATION_OUTSIDE_BRANCH:
      return 1609;
    case ErrorCode.ERROR_CODE_DRIVER_NOT_IN_ORGANIZATION:
      return 1701;
    case ErrorCode.ERROR_CODE_SHIFT_PLAN_DATE_NOT_FUTURE:
      return 1801;
    case ErrorCode.ERROR_CODE_SHIFT_PLAN_USER_NOT_DRIVER:
      return 1802;
    case ErrorCode.ERROR_CODE_CONTACT_NO_PHONE_NUMBER:
      return 1901;
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_MONTH_CLOSED:
      return 2001;
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_APPEND_ONLY:
      return 2002;
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_ALREADY_PRICED:
      return 2003;
    case ErrorCode.ERROR_CODE_DRIVER_PRICE_LIST_PRICE_OUT_OF_RANGE:
      return 2004;
    case ErrorCode.ERROR_CODE_RESOURCE_ACCESS_GRANT_ROLE_NOT_APPLICABLE:
      return 2101;
    case ErrorCode.ERROR_CODE_WHATSAPP_REPLY_WINDOW_CLOSED:
      return 2201;
    case ErrorCode.ERROR_CODE_CUSTOM_GROUP_NAME_TAKEN:
      return 2301;
    case ErrorCode.ERROR_CODE_TYPE_OUTSIDE_HOLDING:
      return 2401;
    case ErrorCode.ERROR_CODE_TYPE_NOT_OWNED:
      return 2402;
    case ErrorCode.ERROR_CODE_TYPE_DUPLICATE_IN_HOLDING:
      return 2403;
    case ErrorCode.ERROR_CODE_TRUCK_TYPE_IN_USE:
      return 2404;
    case ErrorCode.ERROR_CODE_COMPANY_NOT_SELECTED:
      return 9001;
    case ErrorCode.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum ResponseStatus {
  RESPONSE_STATUS_UNDEFINED = "RESPONSE_STATUS_UNDEFINED",
  RESPONSE_STATUS_OK = "RESPONSE_STATUS_OK",
  RESPONSE_STATUS_NOT_FOUND = "RESPONSE_STATUS_NOT_FOUND",
  RESPONSE_STATUS_SERVER_ERROR = "RESPONSE_STATUS_SERVER_ERROR",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function responseStatusFromJSON(object: any): ResponseStatus {
  switch (object) {
    case 0:
    case "RESPONSE_STATUS_UNDEFINED":
      return ResponseStatus.RESPONSE_STATUS_UNDEFINED;
    case 1:
    case "RESPONSE_STATUS_OK":
      return ResponseStatus.RESPONSE_STATUS_OK;
    case 2:
    case "RESPONSE_STATUS_NOT_FOUND":
      return ResponseStatus.RESPONSE_STATUS_NOT_FOUND;
    case 3:
    case "RESPONSE_STATUS_SERVER_ERROR":
      return ResponseStatus.RESPONSE_STATUS_SERVER_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResponseStatus.UNRECOGNIZED;
  }
}

export function responseStatusToJSON(object: ResponseStatus): string {
  switch (object) {
    case ResponseStatus.RESPONSE_STATUS_UNDEFINED:
      return "RESPONSE_STATUS_UNDEFINED";
    case ResponseStatus.RESPONSE_STATUS_OK:
      return "RESPONSE_STATUS_OK";
    case ResponseStatus.RESPONSE_STATUS_NOT_FOUND:
      return "RESPONSE_STATUS_NOT_FOUND";
    case ResponseStatus.RESPONSE_STATUS_SERVER_ERROR:
      return "RESPONSE_STATUS_SERVER_ERROR";
    case ResponseStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function responseStatusToNumber(object: ResponseStatus): number {
  switch (object) {
    case ResponseStatus.RESPONSE_STATUS_UNDEFINED:
      return 0;
    case ResponseStatus.RESPONSE_STATUS_OK:
      return 1;
    case ResponseStatus.RESPONSE_STATUS_NOT_FOUND:
      return 2;
    case ResponseStatus.RESPONSE_STATUS_SERVER_ERROR:
      return 3;
    case ResponseStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum SortDirection {
  SORT_DIRECTION_UNDEFINED = "SORT_DIRECTION_UNDEFINED",
  SORT_DIRECTION_ASCENDING = "SORT_DIRECTION_ASCENDING",
  SORT_DIRECTION_DESCENDING = "SORT_DIRECTION_DESCENDING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function sortDirectionFromJSON(object: any): SortDirection {
  switch (object) {
    case 0:
    case "SORT_DIRECTION_UNDEFINED":
      return SortDirection.SORT_DIRECTION_UNDEFINED;
    case 1:
    case "SORT_DIRECTION_ASCENDING":
      return SortDirection.SORT_DIRECTION_ASCENDING;
    case 2:
    case "SORT_DIRECTION_DESCENDING":
      return SortDirection.SORT_DIRECTION_DESCENDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortDirection.UNRECOGNIZED;
  }
}

export function sortDirectionToJSON(object: SortDirection): string {
  switch (object) {
    case SortDirection.SORT_DIRECTION_UNDEFINED:
      return "SORT_DIRECTION_UNDEFINED";
    case SortDirection.SORT_DIRECTION_ASCENDING:
      return "SORT_DIRECTION_ASCENDING";
    case SortDirection.SORT_DIRECTION_DESCENDING:
      return "SORT_DIRECTION_DESCENDING";
    case SortDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function sortDirectionToNumber(object: SortDirection): number {
  switch (object) {
    case SortDirection.SORT_DIRECTION_UNDEFINED:
      return 0;
    case SortDirection.SORT_DIRECTION_ASCENDING:
      return 1;
    case SortDirection.SORT_DIRECTION_DESCENDING:
      return 2;
    case SortDirection.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * A slim User: user.proto imports organization.proto, so organization.proto and
 * pickup_location.proto cannot nest the full User message without a circular import.
 */
export interface UserRef {
  id: number;
  first_name?: string | undefined;
  last_name?: string | undefined;
  phone_number?: string | undefined;
  email?: string | undefined;
  role?: UserRole | undefined;
}

export interface DateTimeFilter {
  from: Date | undefined;
  to:
    | Date
    | undefined;
  /**
   * Which time column the range applies to, snake_case, e.g. "fact_start_at".
   * Must be a time field of the listed entity; unknown names are rejected.
   * Omitted = the endpoint's default time column.
   * Deprecated: use fields. Not allowed together with fields.
   */
  field?:
    | string
    | undefined;
  /** Like field, but the first non-null column wins, e.g. ["started_at", "tw_start_at"]. */
  fields: string[];
}

export interface DateFilter {
  /**
   * Inclusive start date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   */
  from: string;
  /**
   * Inclusive end date in RFC 3339 full-date format: YYYY-MM-DD.
   * This field is date-only and must not include a time or timezone.
   */
  to: string;
}

export interface ErrorMessage {
  /** To show clients what exactly went wrong, useful for client-side handling */
  code?:
    | ErrorCode
    | undefined;
  /** For developers */
  messages: string[];
  /**
   * Values for the message template a client renders for `code`, e.g.
   * {"id": "15574", "status": "DRIVER_ON_SHIFT_STATUS_IDLE"}. Enum values are
   * sent as their full proto name so the client can localize them too; ids are
   * decimal, timestamps RFC 3339.
   */
  args: { [key: string]: string };
}

export interface ErrorMessage_ArgsEntry {
  key: string;
  value: string;
}

export interface MessageResponse {
  status: ResponseStatus;
  message?: string | undefined;
  error?: ErrorMessage | undefined;
}

export interface EmptyMessageRequest {
}

export interface EmptyMessageResponse {
}

/** A clearable id list in an update: absent keeps the stored list, present and empty clears it. */
export interface IdList {
  ids: number[];
}

export interface IdRequest {
  id: number;
}

export interface ListFilter {
  /** starting from 0 (OFFSET) */
  current_page?:
    | number
    | undefined;
  /** max 100 (LIMIT) */
  page_size?:
    | number
    | undefined;
  /** field name to sort by, default is "id" */
  sort_by?: string | undefined;
  sort_direction?:
    | SortDirection
    | undefined;
  /**
   * Facets to count over the whole match, each returned in ListInfo.facets under its
   * name. Each list request documents the names it supports on its list_filter; any
   * other name is rejected with InvalidArgument.
   */
  facets: string[];
}

/**
 * FacetCounts is one facet's row counts, keyed by enum value. A facet is counted under
 * every filter of the request but its own, so a tab keeps its count while selected.
 * Every value of the enum is present, 0 where nothing matched; a value the enum does
 * not know (legacy, empty, NULL) counts under its zero value, UNDEFINED, present only
 * when nonzero. Clients never show UNDEFINED on its own.
 */
export interface FacetCounts {
  counts: { [key: number]: number };
  /**
   * Id facets (a reference column) count here instead, keyed by the referenced id;
   * key 0 counts the rows with no value, as id 0 filters them. An id missing from the
   * map counts 0.
   */
  id_counts: { [key: number]: number };
}

export interface FacetCounts_CountsEntry {
  key: number;
  value: number;
}

export interface FacetCounts_IdCountsEntry {
  key: number;
  value: number;
}

export interface ListInfo {
  total_items: number;
  /** <-- ListFilter.current_page */
  current_page: number;
  /** <-- ListFilter.page_size */
  page_size: number;
  sort_by?: string | undefined;
  sort_direction?:
    | SortDirection
    | undefined;
  /** The requested ListFilter.facets, by name. */
  facets: { [key: string]: FacetCounts };
}

export interface ListInfo_FacetsEntry {
  key: string;
  value: FacetCounts | undefined;
}

/**
 * An organization's own label: pickup location types, customer types. A name for
 * filtering and display only, no business rule depends on it. Unlike TruckType or
 * ContainerType, it carries no attributes; add a new label kind, not fields here.
 */
export interface OrganizationLabel {
  id: number;
  owner_organization_id: number;
  name: string;
  /** INACTIVE is the archive: kept where already assigned, not assignable. */
  status: LocationStatus;
  created_at: Date | undefined;
  updated_at?: Date | undefined;
}

export interface OrganizationLabelCreate {
  owner_organization_id: number;
  name: string;
}

export interface OrganizationLabelUpdate {
  id: number;
  owner_organization_id: number;
  name?: string | undefined;
  status?: LocationStatus | undefined;
}

export interface OrganizationLabelListRequest {
  owner_organization_ids: number[];
  statuses: LocationStatus[];
  /** facets: "status" (LocationStatus). */
  list_filter?: ListFilter | undefined;
}

export interface OrganizationLabelList {
  labels: OrganizationLabel[];
  list_info?: ListInfo | undefined;
}

function createBaseUserRef(): UserRef {
  return { id: 0, first_name: "", last_name: "", phone_number: "", email: "", role: UserRole.USER_ROLE_UNDEFINED };
}

export const UserRef: MessageFns<UserRef> = {
  encode(message: UserRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.first_name !== undefined && message.first_name !== "") {
      writer.uint32(18).string(message.first_name);
    }
    if (message.last_name !== undefined && message.last_name !== "") {
      writer.uint32(26).string(message.last_name);
    }
    if (message.phone_number !== undefined && message.phone_number !== "") {
      writer.uint32(34).string(message.phone_number);
    }
    if (message.email !== undefined && message.email !== "") {
      writer.uint32(42).string(message.email);
    }
    if (message.role !== undefined && message.role !== UserRole.USER_ROLE_UNDEFINED) {
      writer.uint32(48).int32(userRoleToNumber(message.role));
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserRef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.first_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.last_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.phone_number = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.role = userRoleFromJSON(reader.int32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserRef {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      first_name: isSet(object.first_name) ? globalThis.String(object.first_name) : "",
      last_name: isSet(object.last_name) ? globalThis.String(object.last_name) : "",
      phone_number: isSet(object.phone_number) ? globalThis.String(object.phone_number) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      role: isSet(object.role) ? userRoleFromJSON(object.role) : UserRole.USER_ROLE_UNDEFINED,
    };
  },

  toJSON(message: UserRef): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.first_name !== undefined && message.first_name !== "") {
      obj.first_name = message.first_name;
    }
    if (message.last_name !== undefined && message.last_name !== "") {
      obj.last_name = message.last_name;
    }
    if (message.phone_number !== undefined && message.phone_number !== "") {
      obj.phone_number = message.phone_number;
    }
    if (message.email !== undefined && message.email !== "") {
      obj.email = message.email;
    }
    if (message.role !== undefined && message.role !== UserRole.USER_ROLE_UNDEFINED) {
      obj.role = userRoleToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserRef>, I>>(base?: I): UserRef {
    return UserRef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserRef>, I>>(object: I): UserRef {
    const message = createBaseUserRef();
    message.id = object.id ?? 0;
    message.first_name = object.first_name ?? "";
    message.last_name = object.last_name ?? "";
    message.phone_number = object.phone_number ?? "";
    message.email = object.email ?? "";
    message.role = object.role ?? UserRole.USER_ROLE_UNDEFINED;
    return message;
  },
};

function createBaseDateTimeFilter(): DateTimeFilter {
  return { from: undefined, to: undefined, field: "", fields: [] };
}

export const DateTimeFilter: MessageFns<DateTimeFilter> = {
  encode(message: DateTimeFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== undefined) {
      Timestamp.encode(toTimestamp(message.from), writer.uint32(10).fork()).join();
    }
    if (message.to !== undefined) {
      Timestamp.encode(toTimestamp(message.to), writer.uint32(18).fork()).join();
    }
    if (message.field !== undefined && message.field !== "") {
      writer.uint32(26).string(message.field);
    }
    for (const v of message.fields) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateTimeFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.from = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.to = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.field = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fields.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateTimeFilter {
    return {
      from: isSet(object.from) ? fromJsonTimestamp(object.from) : undefined,
      to: isSet(object.to) ? fromJsonTimestamp(object.to) : undefined,
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: DateTimeFilter): unknown {
    const obj: any = {};
    if (message.from !== undefined) {
      obj.from = message.from.toISOString();
    }
    if (message.to !== undefined) {
      obj.to = message.to.toISOString();
    }
    if (message.field !== undefined && message.field !== "") {
      obj.field = message.field;
    }
    if (message.fields?.length) {
      obj.fields = message.fields;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeFilter>, I>>(base?: I): DateTimeFilter {
    return DateTimeFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeFilter>, I>>(object: I): DateTimeFilter {
    const message = createBaseDateTimeFilter();
    message.from = object.from ?? undefined;
    message.to = object.to ?? undefined;
    message.field = object.field ?? "";
    message.fields = object.fields?.map((e) => e) || [];
    return message;
  },
};

function createBaseDateFilter(): DateFilter {
  return { from: "", to: "" };
}

export const DateFilter: MessageFns<DateFilter> = {
  encode(message: DateFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.from !== "") {
      writer.uint32(10).string(message.from);
    }
    if (message.to !== "") {
      writer.uint32(18).string(message.to);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDateFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.from = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.to = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DateFilter {
    return {
      from: isSet(object.from) ? globalThis.String(object.from) : "",
      to: isSet(object.to) ? globalThis.String(object.to) : "",
    };
  },

  toJSON(message: DateFilter): unknown {
    const obj: any = {};
    if (message.from !== "") {
      obj.from = message.from;
    }
    if (message.to !== "") {
      obj.to = message.to;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateFilter>, I>>(base?: I): DateFilter {
    return DateFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateFilter>, I>>(object: I): DateFilter {
    const message = createBaseDateFilter();
    message.from = object.from ?? "";
    message.to = object.to ?? "";
    return message;
  },
};

function createBaseErrorMessage(): ErrorMessage {
  return { code: ErrorCode.ERROR_CODE_UNDEFINED, messages: [], args: {} };
}

export const ErrorMessage: MessageFns<ErrorMessage> = {
  encode(message: ErrorMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== undefined && message.code !== ErrorCode.ERROR_CODE_UNDEFINED) {
      writer.uint32(8).int32(errorCodeToNumber(message.code));
    }
    for (const v of message.messages) {
      writer.uint32(18).string(v!);
    }
    Object.entries(message.args).forEach(([key, value]) => {
      ErrorMessage_ArgsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = errorCodeFromJSON(reader.int32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = ErrorMessage_ArgsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.args[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorMessage {
    return {
      code: isSet(object.code) ? errorCodeFromJSON(object.code) : ErrorCode.ERROR_CODE_UNDEFINED,
      messages: globalThis.Array.isArray(object?.messages) ? object.messages.map((e: any) => globalThis.String(e)) : [],
      args: isObject(object.args)
        ? Object.entries(object.args).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ErrorMessage): unknown {
    const obj: any = {};
    if (message.code !== undefined && message.code !== ErrorCode.ERROR_CODE_UNDEFINED) {
      obj.code = errorCodeToJSON(message.code);
    }
    if (message.messages?.length) {
      obj.messages = message.messages;
    }
    if (message.args) {
      const entries = Object.entries(message.args);
      if (entries.length > 0) {
        obj.args = {};
        entries.forEach(([k, v]) => {
          obj.args[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorMessage>, I>>(base?: I): ErrorMessage {
    return ErrorMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorMessage>, I>>(object: I): ErrorMessage {
    const message = createBaseErrorMessage();
    message.code = object.code ?? ErrorCode.ERROR_CODE_UNDEFINED;
    message.messages = object.messages?.map((e) => e) || [];
    message.args = Object.entries(object.args ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseErrorMessage_ArgsEntry(): ErrorMessage_ArgsEntry {
  return { key: "", value: "" };
}

export const ErrorMessage_ArgsEntry: MessageFns<ErrorMessage_ArgsEntry> = {
  encode(message: ErrorMessage_ArgsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorMessage_ArgsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorMessage_ArgsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorMessage_ArgsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ErrorMessage_ArgsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorMessage_ArgsEntry>, I>>(base?: I): ErrorMessage_ArgsEntry {
    return ErrorMessage_ArgsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorMessage_ArgsEntry>, I>>(object: I): ErrorMessage_ArgsEntry {
    const message = createBaseErrorMessage_ArgsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseMessageResponse(): MessageResponse {
  return { status: ResponseStatus.RESPONSE_STATUS_UNDEFINED, message: "", error: undefined };
}

export const MessageResponse: MessageFns<MessageResponse> = {
  encode(message: MessageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== ResponseStatus.RESPONSE_STATUS_UNDEFINED) {
      writer.uint32(8).int32(responseStatusToNumber(message.status));
    }
    if (message.message !== undefined && message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.error !== undefined) {
      ErrorMessage.encode(message.error, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = responseStatusFromJSON(reader.int32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = ErrorMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageResponse {
    return {
      status: isSet(object.status) ? responseStatusFromJSON(object.status) : ResponseStatus.RESPONSE_STATUS_UNDEFINED,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      error: isSet(object.error) ? ErrorMessage.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: MessageResponse): unknown {
    const obj: any = {};
    if (message.status !== ResponseStatus.RESPONSE_STATUS_UNDEFINED) {
      obj.status = responseStatusToJSON(message.status);
    }
    if (message.message !== undefined && message.message !== "") {
      obj.message = message.message;
    }
    if (message.error !== undefined) {
      obj.error = ErrorMessage.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessageResponse>, I>>(base?: I): MessageResponse {
    return MessageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessageResponse>, I>>(object: I): MessageResponse {
    const message = createBaseMessageResponse();
    message.status = object.status ?? ResponseStatus.RESPONSE_STATUS_UNDEFINED;
    message.message = object.message ?? "";
    message.error = (object.error !== undefined && object.error !== null)
      ? ErrorMessage.fromPartial(object.error)
      : undefined;
    return message;
  },
};

function createBaseEmptyMessageRequest(): EmptyMessageRequest {
  return {};
}

export const EmptyMessageRequest: MessageFns<EmptyMessageRequest> = {
  encode(_: EmptyMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EmptyMessageRequest {
    return {};
  },

  toJSON(_: EmptyMessageRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyMessageRequest>, I>>(base?: I): EmptyMessageRequest {
    return EmptyMessageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyMessageRequest>, I>>(_: I): EmptyMessageRequest {
    const message = createBaseEmptyMessageRequest();
    return message;
  },
};

function createBaseEmptyMessageResponse(): EmptyMessageResponse {
  return {};
}

export const EmptyMessageResponse: MessageFns<EmptyMessageResponse> = {
  encode(_: EmptyMessageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmptyMessageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyMessageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EmptyMessageResponse {
    return {};
  },

  toJSON(_: EmptyMessageResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EmptyMessageResponse>, I>>(base?: I): EmptyMessageResponse {
    return EmptyMessageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmptyMessageResponse>, I>>(_: I): EmptyMessageResponse {
    const message = createBaseEmptyMessageResponse();
    return message;
  },
};

function createBaseIdList(): IdList {
  return { ids: [] };
}

export const IdList: MessageFns<IdList> = {
  encode(message: IdList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(8).uint64(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.ids.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ids.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdList {
    return { ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.Number(e)) : [] };
  },

  toJSON(message: IdList): unknown {
    const obj: any = {};
    if (message.ids?.length) {
      obj.ids = message.ids.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IdList>, I>>(base?: I): IdList {
    return IdList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IdList>, I>>(object: I): IdList {
    const message = createBaseIdList();
    message.ids = object.ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseIdRequest(): IdRequest {
  return { id: 0 };
}

export const IdRequest: MessageFns<IdRequest> = {
  encode(message: IdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdRequest {
    return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
  },

  toJSON(message: IdRequest): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IdRequest>, I>>(base?: I): IdRequest {
    return IdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IdRequest>, I>>(object: I): IdRequest {
    const message = createBaseIdRequest();
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseListFilter(): ListFilter {
  return {
    current_page: 0,
    page_size: 50,
    sort_by: "id",
    sort_direction: SortDirection.SORT_DIRECTION_DESCENDING,
    facets: [],
  };
}

export const ListFilter: MessageFns<ListFilter> = {
  encode(message: ListFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.current_page !== undefined && message.current_page !== 0) {
      writer.uint32(8).uint32(message.current_page);
    }
    if (message.page_size !== undefined && message.page_size !== 50) {
      writer.uint32(16).uint32(message.page_size);
    }
    if (message.sort_by !== undefined && message.sort_by !== "id") {
      writer.uint32(26).string(message.sort_by);
    }
    if (message.sort_direction !== undefined && message.sort_direction !== SortDirection.SORT_DIRECTION_UNDEFINED) {
      writer.uint32(32).int32(sortDirectionToNumber(message.sort_direction));
    }
    for (const v of message.facets) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.current_page = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.page_size = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sort_by = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sort_direction = sortDirectionFromJSON(reader.int32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.facets.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListFilter {
    return {
      current_page: isSet(object.current_page) ? globalThis.Number(object.current_page) : 0,
      page_size: isSet(object.page_size) ? globalThis.Number(object.page_size) : 50,
      sort_by: isSet(object.sort_by) ? globalThis.String(object.sort_by) : "id",
      sort_direction: isSet(object.sort_direction)
        ? sortDirectionFromJSON(object.sort_direction)
        : SortDirection.SORT_DIRECTION_DESCENDING,
      facets: globalThis.Array.isArray(object?.facets) ? object.facets.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ListFilter): unknown {
    const obj: any = {};
    if (message.current_page !== undefined && message.current_page !== 0) {
      obj.current_page = Math.round(message.current_page);
    }
    if (message.page_size !== undefined && message.page_size !== 50) {
      obj.page_size = Math.round(message.page_size);
    }
    if (message.sort_by !== undefined && message.sort_by !== "id") {
      obj.sort_by = message.sort_by;
    }
    if (message.sort_direction !== undefined && message.sort_direction !== SortDirection.SORT_DIRECTION_UNDEFINED) {
      obj.sort_direction = sortDirectionToJSON(message.sort_direction);
    }
    if (message.facets?.length) {
      obj.facets = message.facets;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListFilter>, I>>(base?: I): ListFilter {
    return ListFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListFilter>, I>>(object: I): ListFilter {
    const message = createBaseListFilter();
    message.current_page = object.current_page ?? 0;
    message.page_size = object.page_size ?? 50;
    message.sort_by = object.sort_by ?? "id";
    message.sort_direction = object.sort_direction ?? SortDirection.SORT_DIRECTION_DESCENDING;
    message.facets = object.facets?.map((e) => e) || [];
    return message;
  },
};

function createBaseFacetCounts(): FacetCounts {
  return { counts: {}, id_counts: {} };
}

export const FacetCounts: MessageFns<FacetCounts> = {
  encode(message: FacetCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.counts).forEach(([key, value]) => {
      FacetCounts_CountsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    Object.entries(message.id_counts).forEach(([key, value]) => {
      FacetCounts_IdCountsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FacetCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFacetCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = FacetCounts_CountsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.counts[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = FacetCounts_IdCountsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.id_counts[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FacetCounts {
    return {
      counts: isObject(object.counts)
        ? Object.entries(object.counts).reduce<{ [key: number]: number }>((acc, [key, value]) => {
          acc[globalThis.Number(key)] = Number(value);
          return acc;
        }, {})
        : {},
      id_counts: isObject(object.id_counts)
        ? Object.entries(object.id_counts).reduce<{ [key: number]: number }>((acc, [key, value]) => {
          acc[globalThis.Number(key)] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: FacetCounts): unknown {
    const obj: any = {};
    if (message.counts) {
      const entries = Object.entries(message.counts);
      if (entries.length > 0) {
        obj.counts = {};
        entries.forEach(([k, v]) => {
          obj.counts[k] = Math.round(v);
        });
      }
    }
    if (message.id_counts) {
      const entries = Object.entries(message.id_counts);
      if (entries.length > 0) {
        obj.id_counts = {};
        entries.forEach(([k, v]) => {
          obj.id_counts[k] = Math.round(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FacetCounts>, I>>(base?: I): FacetCounts {
    return FacetCounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FacetCounts>, I>>(object: I): FacetCounts {
    const message = createBaseFacetCounts();
    message.counts = Object.entries(object.counts ?? {}).reduce<{ [key: number]: number }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[globalThis.Number(key)] = globalThis.Number(value);
      }
      return acc;
    }, {});
    message.id_counts = Object.entries(object.id_counts ?? {}).reduce<{ [key: number]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseFacetCounts_CountsEntry(): FacetCounts_CountsEntry {
  return { key: 0, value: 0 };
}

export const FacetCounts_CountsEntry: MessageFns<FacetCounts_CountsEntry> = {
  encode(message: FacetCounts_CountsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).uint32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FacetCounts_CountsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFacetCounts_CountsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FacetCounts_CountsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: FacetCounts_CountsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FacetCounts_CountsEntry>, I>>(base?: I): FacetCounts_CountsEntry {
    return FacetCounts_CountsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FacetCounts_CountsEntry>, I>>(object: I): FacetCounts_CountsEntry {
    const message = createBaseFacetCounts_CountsEntry();
    message.key = object.key ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseFacetCounts_IdCountsEntry(): FacetCounts_IdCountsEntry {
  return { key: 0, value: 0 };
}

export const FacetCounts_IdCountsEntry: MessageFns<FacetCounts_IdCountsEntry> = {
  encode(message: FacetCounts_IdCountsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).uint64(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).uint32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FacetCounts_IdCountsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFacetCounts_IdCountsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FacetCounts_IdCountsEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: FacetCounts_IdCountsEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FacetCounts_IdCountsEntry>, I>>(base?: I): FacetCounts_IdCountsEntry {
    return FacetCounts_IdCountsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FacetCounts_IdCountsEntry>, I>>(object: I): FacetCounts_IdCountsEntry {
    const message = createBaseFacetCounts_IdCountsEntry();
    message.key = object.key ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseListInfo(): ListInfo {
  return {
    total_items: 0,
    current_page: 0,
    page_size: 0,
    sort_by: "id",
    sort_direction: SortDirection.SORT_DIRECTION_DESCENDING,
    facets: {},
  };
}

export const ListInfo: MessageFns<ListInfo> = {
  encode(message: ListInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total_items !== 0) {
      writer.uint32(8).uint32(message.total_items);
    }
    if (message.current_page !== 0) {
      writer.uint32(16).uint32(message.current_page);
    }
    if (message.page_size !== 0) {
      writer.uint32(24).uint32(message.page_size);
    }
    if (message.sort_by !== undefined && message.sort_by !== "id") {
      writer.uint32(34).string(message.sort_by);
    }
    if (message.sort_direction !== undefined && message.sort_direction !== SortDirection.SORT_DIRECTION_UNDEFINED) {
      writer.uint32(40).int32(sortDirectionToNumber(message.sort_direction));
    }
    Object.entries(message.facets).forEach(([key, value]) => {
      ListInfo_FacetsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.total_items = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.current_page = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.page_size = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sort_by = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.sort_direction = sortDirectionFromJSON(reader.int32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = ListInfo_FacetsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.facets[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInfo {
    return {
      total_items: isSet(object.total_items) ? globalThis.Number(object.total_items) : 0,
      current_page: isSet(object.current_page) ? globalThis.Number(object.current_page) : 0,
      page_size: isSet(object.page_size) ? globalThis.Number(object.page_size) : 0,
      sort_by: isSet(object.sort_by) ? globalThis.String(object.sort_by) : "id",
      sort_direction: isSet(object.sort_direction)
        ? sortDirectionFromJSON(object.sort_direction)
        : SortDirection.SORT_DIRECTION_DESCENDING,
      facets: isObject(object.facets)
        ? Object.entries(object.facets).reduce<{ [key: string]: FacetCounts }>((acc, [key, value]) => {
          acc[key] = FacetCounts.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ListInfo): unknown {
    const obj: any = {};
    if (message.total_items !== 0) {
      obj.total_items = Math.round(message.total_items);
    }
    if (message.current_page !== 0) {
      obj.current_page = Math.round(message.current_page);
    }
    if (message.page_size !== 0) {
      obj.page_size = Math.round(message.page_size);
    }
    if (message.sort_by !== undefined && message.sort_by !== "id") {
      obj.sort_by = message.sort_by;
    }
    if (message.sort_direction !== undefined && message.sort_direction !== SortDirection.SORT_DIRECTION_UNDEFINED) {
      obj.sort_direction = sortDirectionToJSON(message.sort_direction);
    }
    if (message.facets) {
      const entries = Object.entries(message.facets);
      if (entries.length > 0) {
        obj.facets = {};
        entries.forEach(([k, v]) => {
          obj.facets[k] = FacetCounts.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInfo>, I>>(base?: I): ListInfo {
    return ListInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInfo>, I>>(object: I): ListInfo {
    const message = createBaseListInfo();
    message.total_items = object.total_items ?? 0;
    message.current_page = object.current_page ?? 0;
    message.page_size = object.page_size ?? 0;
    message.sort_by = object.sort_by ?? "id";
    message.sort_direction = object.sort_direction ?? SortDirection.SORT_DIRECTION_DESCENDING;
    message.facets = Object.entries(object.facets ?? {}).reduce<{ [key: string]: FacetCounts }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = FacetCounts.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseListInfo_FacetsEntry(): ListInfo_FacetsEntry {
  return { key: "", value: undefined };
}

export const ListInfo_FacetsEntry: MessageFns<ListInfo_FacetsEntry> = {
  encode(message: ListInfo_FacetsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FacetCounts.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInfo_FacetsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInfo_FacetsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = FacetCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInfo_FacetsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? FacetCounts.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListInfo_FacetsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = FacetCounts.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListInfo_FacetsEntry>, I>>(base?: I): ListInfo_FacetsEntry {
    return ListInfo_FacetsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListInfo_FacetsEntry>, I>>(object: I): ListInfo_FacetsEntry {
    const message = createBaseListInfo_FacetsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? FacetCounts.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseOrganizationLabel(): OrganizationLabel {
  return {
    id: 0,
    owner_organization_id: 0,
    name: "",
    status: LocationStatus.LOCATION_STATUS_UNDEFINED,
    created_at: undefined,
    updated_at: undefined,
  };
}

export const OrganizationLabel: MessageFns<OrganizationLabel> = {
  encode(message: OrganizationLabel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.owner_organization_id !== 0) {
      writer.uint32(16).uint64(message.owner_organization_id);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.status !== LocationStatus.LOCATION_STATUS_UNDEFINED) {
      writer.uint32(32).int32(locationStatusToNumber(message.status));
    }
    if (message.created_at !== undefined) {
      Timestamp.encode(toTimestamp(message.created_at), writer.uint32(810).fork()).join();
    }
    if (message.updated_at !== undefined) {
      Timestamp.encode(toTimestamp(message.updated_at), writer.uint32(818).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationLabel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationLabel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.owner_organization_id = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = locationStatusFromJSON(reader.int32());
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.created_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.updated_at = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationLabel {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      owner_organization_id: isSet(object.owner_organization_id) ? globalThis.Number(object.owner_organization_id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? locationStatusFromJSON(object.status) : LocationStatus.LOCATION_STATUS_UNDEFINED,
      created_at: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : undefined,
      updated_at: isSet(object.updated_at) ? fromJsonTimestamp(object.updated_at) : undefined,
    };
  },

  toJSON(message: OrganizationLabel): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.owner_organization_id !== 0) {
      obj.owner_organization_id = Math.round(message.owner_organization_id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== LocationStatus.LOCATION_STATUS_UNDEFINED) {
      obj.status = locationStatusToJSON(message.status);
    }
    if (message.created_at !== undefined) {
      obj.created_at = message.created_at.toISOString();
    }
    if (message.updated_at !== undefined) {
      obj.updated_at = message.updated_at.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationLabel>, I>>(base?: I): OrganizationLabel {
    return OrganizationLabel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationLabel>, I>>(object: I): OrganizationLabel {
    const message = createBaseOrganizationLabel();
    message.id = object.id ?? 0;
    message.owner_organization_id = object.owner_organization_id ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? LocationStatus.LOCATION_STATUS_UNDEFINED;
    message.created_at = object.created_at ?? undefined;
    message.updated_at = object.updated_at ?? undefined;
    return message;
  },
};

function createBaseOrganizationLabelCreate(): OrganizationLabelCreate {
  return { owner_organization_id: 0, name: "" };
}

export const OrganizationLabelCreate: MessageFns<OrganizationLabelCreate> = {
  encode(message: OrganizationLabelCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.owner_organization_id !== 0) {
      writer.uint32(8).uint64(message.owner_organization_id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationLabelCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationLabelCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.owner_organization_id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationLabelCreate {
    return {
      owner_organization_id: isSet(object.owner_organization_id) ? globalThis.Number(object.owner_organization_id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: OrganizationLabelCreate): unknown {
    const obj: any = {};
    if (message.owner_organization_id !== 0) {
      obj.owner_organization_id = Math.round(message.owner_organization_id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationLabelCreate>, I>>(base?: I): OrganizationLabelCreate {
    return OrganizationLabelCreate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationLabelCreate>, I>>(object: I): OrganizationLabelCreate {
    const message = createBaseOrganizationLabelCreate();
    message.owner_organization_id = object.owner_organization_id ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseOrganizationLabelUpdate(): OrganizationLabelUpdate {
  return { id: 0, owner_organization_id: 0, name: "", status: LocationStatus.LOCATION_STATUS_UNDEFINED };
}

export const OrganizationLabelUpdate: MessageFns<OrganizationLabelUpdate> = {
  encode(message: OrganizationLabelUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.owner_organization_id !== 0) {
      writer.uint32(16).uint64(message.owner_organization_id);
    }
    if (message.name !== undefined && message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.status !== undefined && message.status !== LocationStatus.LOCATION_STATUS_UNDEFINED) {
      writer.uint32(32).int32(locationStatusToNumber(message.status));
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationLabelUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationLabelUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.owner_organization_id = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = locationStatusFromJSON(reader.int32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationLabelUpdate {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      owner_organization_id: isSet(object.owner_organization_id) ? globalThis.Number(object.owner_organization_id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      status: isSet(object.status) ? locationStatusFromJSON(object.status) : LocationStatus.LOCATION_STATUS_UNDEFINED,
    };
  },

  toJSON(message: OrganizationLabelUpdate): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.owner_organization_id !== 0) {
      obj.owner_organization_id = Math.round(message.owner_organization_id);
    }
    if (message.name !== undefined && message.name !== "") {
      obj.name = message.name;
    }
    if (message.status !== undefined && message.status !== LocationStatus.LOCATION_STATUS_UNDEFINED) {
      obj.status = locationStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationLabelUpdate>, I>>(base?: I): OrganizationLabelUpdate {
    return OrganizationLabelUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationLabelUpdate>, I>>(object: I): OrganizationLabelUpdate {
    const message = createBaseOrganizationLabelUpdate();
    message.id = object.id ?? 0;
    message.owner_organization_id = object.owner_organization_id ?? 0;
    message.name = object.name ?? "";
    message.status = object.status ?? LocationStatus.LOCATION_STATUS_UNDEFINED;
    return message;
  },
};

function createBaseOrganizationLabelListRequest(): OrganizationLabelListRequest {
  return { owner_organization_ids: [], statuses: [], list_filter: undefined };
}

export const OrganizationLabelListRequest: MessageFns<OrganizationLabelListRequest> = {
  encode(message: OrganizationLabelListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.owner_organization_ids) {
      writer.uint32(8).uint64(v!);
    }
    for (const v of message.statuses) {
      writer.uint32(16).int32(locationStatusToNumber(v!));
    }
    if (message.list_filter !== undefined) {
      ListFilter.encode(message.list_filter, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationLabelListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationLabelListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.owner_organization_ids.push(longToNumber(reader.uint64()));

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.owner_organization_ids.push(longToNumber(reader.uint64()));
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 16) {
            message.statuses.push(locationStatusFromJSON(reader.int32()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.statuses.push(locationStatusFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.list_filter = ListFilter.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationLabelListRequest {
    return {
      owner_organization_ids: globalThis.Array.isArray(object?.owner_organization_ids)
        ? object.owner_organization_ids.map((e: any) => globalThis.Number(e))
        : [],
      statuses: globalThis.Array.isArray(object?.statuses)
        ? object.statuses.map((e: any) => locationStatusFromJSON(e))
        : [],
      list_filter: isSet(object.list_filter) ? ListFilter.fromJSON(object.list_filter) : undefined,
    };
  },

  toJSON(message: OrganizationLabelListRequest): unknown {
    const obj: any = {};
    if (message.owner_organization_ids?.length) {
      obj.owner_organization_ids = message.owner_organization_ids.map((e) => Math.round(e));
    }
    if (message.statuses?.length) {
      obj.statuses = message.statuses.map((e) => locationStatusToJSON(e));
    }
    if (message.list_filter !== undefined) {
      obj.list_filter = ListFilter.toJSON(message.list_filter);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationLabelListRequest>, I>>(base?: I): OrganizationLabelListRequest {
    return OrganizationLabelListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationLabelListRequest>, I>>(object: I): OrganizationLabelListRequest {
    const message = createBaseOrganizationLabelListRequest();
    message.owner_organization_ids = object.owner_organization_ids?.map((e) => e) || [];
    message.statuses = object.statuses?.map((e) => e) || [];
    message.list_filter = (object.list_filter !== undefined && object.list_filter !== null)
      ? ListFilter.fromPartial(object.list_filter)
      : undefined;
    return message;
  },
};

function createBaseOrganizationLabelList(): OrganizationLabelList {
  return { labels: [], list_info: undefined };
}

export const OrganizationLabelList: MessageFns<OrganizationLabelList> = {
  encode(message: OrganizationLabelList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.labels) {
      OrganizationLabel.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.list_info !== undefined) {
      ListInfo.encode(message.list_info, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationLabelList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationLabelList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.labels.push(OrganizationLabel.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.list_info = ListInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationLabelList {
    return {
      labels: globalThis.Array.isArray(object?.labels)
        ? object.labels.map((e: any) => OrganizationLabel.fromJSON(e))
        : [],
      list_info: isSet(object.list_info) ? ListInfo.fromJSON(object.list_info) : undefined,
    };
  },

  toJSON(message: OrganizationLabelList): unknown {
    const obj: any = {};
    if (message.labels?.length) {
      obj.labels = message.labels.map((e) => OrganizationLabel.toJSON(e));
    }
    if (message.list_info !== undefined) {
      obj.list_info = ListInfo.toJSON(message.list_info);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrganizationLabelList>, I>>(base?: I): OrganizationLabelList {
    return OrganizationLabelList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrganizationLabelList>, I>>(object: I): OrganizationLabelList {
    const message = createBaseOrganizationLabelList();
    message.labels = object.labels?.map((e) => OrganizationLabel.fromPartial(e)) || [];
    message.list_info = (object.list_info !== undefined && object.list_info !== null)
      ? ListInfo.fromPartial(object.list_info)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
